import React from 'react'
import 'react-toastify/dist/ReactToastify.css'
import { ToastContainer, toast } from 'react-toastify'
import {
  Row,
  Input,
  Col,
  Button,
  Form,
  Select,
  Modal,
  Table,
  DatePicker,
  Popconfirm,
  Layout,
  message,
  Upload,
  Card,
  Radio,
  Checkbox,
  Tooltip
} from 'antd'
import * as XLSX from 'xlsx'
import { saveAs } from 'file-saver'
import { withRouter } from 'react-router-dom'

import {
  CloseOutlined,
  CloudDownloadOutlined,
  CloudUploadOutlined,
  DeleteOutlined,
  DownloadOutlined,
  FileExcelOutlined,
  FileTextOutlined,
  EditOutlined,
} from '@ant-design/icons'

import * as moment from 'moment'
import { Spin } from 'antd'
//import { eventManager } from 'react-toastify/dist/core'
import { eventManager } from 'react-toastify'
import apiRequest from '../../hooks/ApiRequest'
import { sync } from 'resolve'
import Mini from '../steps/Mini'
import { template } from '@babel/core'
import { parse } from 'query-string'

const { Option } = Select
function roundvalue(value) {
  if (value > 0) {
    return parseFloat(value.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0])
  }
}

const productNameInLocalStorage = localStorage.getItem('productName')

const { confirm } = Modal

class HomeInsurancePolicy extends React.Component {
  constructor(props) {
    super(props)
    this.myRef = React.createRef(null)
    this.myRefAddress = React.createRef(null)
    this.uploadProps = {
      beforeUpload: this.handleExcelUpload,
      showUploadList: false,
      accept: '.xlsx, .xls',
    }
    this.state = {
      // customerSearch:"",
      quotationsNumberParams: this.props.match.params.quotationNumber,
      RoleList: [],
      taxes: [],
      RoleId: '',
      nationalid10: true,
      nationalboolData: '',
      policyDuration: '12',
      minimumPremium: 0,
      isCustomerNew: false,
      clickYes: false,
      nationalid: '',
      data1: '',
      editingRecordId: null,
      customerName15: '',
      searchQuery: '',
      filteredCustomers: [],
      CustomerDetails1: [],
      isCorprate: 'false',
      isTableViible: 'false',
      searchBox: null,
      gotData: false,
      visible: false,
      riskItemValue: '',
      visibleSearch: false,
      isRequired: true,
      access: '',
      a: false,
      riskCover: '',
      riskItem: '',
      data: [],
      excelData: [],
      dataForFCP: [],
      riskCoverDrop: [],
      riskItemList: [],
      riskVar: '',
      ratePercentage: '',
      rate: 0.0,
      riskcoverfortable: '',
      riskitemfortable: '',
      monthlyPaymentInLegalAid: 0,
      monthlyTotalPayment: 0.0,
      newProduct: {},
      newProductForFCP: {},
      addressifNotBuilding: '',
      productid: 0,
      specificProductID: 0,
      insurerID: 0,
      prorataPremiumTotal: 0.0,
      annualPremiumTotal: 0.0,
      termPremiumTotal: 0.0,
      tempAddress: '',
      policyStartDate: new Date(),
      policyEndDate: new Date(),
      riskitemid: '',
      paymentterm: '',
      monthlyTermPayment: 0,
      isMonthlyDeduction: false,
      policyriskcover: '',
      clientfirstname: '',
      clientsurname: '',
      clientcorporatename: '',
      clientcontactnumber: '',
      clientemailaddress: '',
      clientDob: '2015-06-06',
      clientage: '',
      clientgender: '',
      clientaddress1: '',
      clientaddress2: '',
      customerid: 0,
      suburb: '',
      city: '',
      record: '',
      count: 0,
      entitytype: '',
      res: [],
      dateFormat: 'DD-MM-YYYY',
      stampDuty: '',
      riskItemStartDate: new Date(),
      currentDate: new Date(),
      currency: '',
      currencyList: [],
      reinsuranceLimit: '',
      loading: false,
      loggedInId: parseInt(localStorage.getItem('loggedInUserID')),
      cellphone: false,
      coverType: '',
      baseData: [],
      customerData: [],
      insurerList: [],
      selectedInsurer: '',
      insurerEmail: '',
      UserDetail: JSON.parse(localStorage.getItem('user')),
      productId: parseInt(localStorage.getItem('productId')),
      productName: localStorage.getItem('productName'),
      sumInsuredTotalFCP: 0,
      title: '',
      monthlyPremiumTotal: 0,
      ageFcp: '',
      ageRanges: [],
      policyCoverValue: '',
      monthlyPaymentValues: 0,
      addressValue: '',
      DObValue: null,
      relationValue: '',
      sumInsuredValue: 0,
      totalSumInsured: 0,
      Minimum_rate: 0,
      VehicleRegistration: '',
      Make: '',
      Model: '',
      Year: '',
      genericProductId: localStorage.getItem('productId'),
      invalidExcelRecords: [],
      validExcelRecords: [],
      templateUrl: [],
      currencyDisabled: false,
      disableAddFieldValidation: false,
      token: localStorage.getItem('token'),
      grandTotals: {},
      footerTotals: {},
      selectedForm:
        parseInt(localStorage.getItem('productId')) == 10 ? '' : 'form2',
      columns: [
        {
          key: 'risk_item',
          title: 'Policy Cover',
          dataIndex: 'policy_cover',
        },
        {
          key: 'riskitem',
          title: 'Risk Item',
          dataIndex: 'riskitemname',
        },
        {
          key: 'address',
          title: 'Address/Details',
          dataIndex: 'address',
        },

        ...(productNameInLocalStorage === 'LEGAL INSURANCE'
          ? [
            {
              key: 'monthlyPayment',
              title: 'Monthly Payment($)',
              dataIndex: 'monthlyPayment',
            },
          ]
          : [
            {
              key: 'suminsured',
              title: 'Sum Insured',
              dataIndex: 'suminsured',
            },
            {
              key: 'rate',
              title: 'Rate(%)',
              dataIndex: 'rate',
            },
            // {
            //   key: 'Proratapremium',
            //   title: 'Prorata Premium',
            //   dataIndex: 'prorata',
            // },
            {
              key: 'annualpremium',
              title: 'Annual Premium',
              dataIndex: 'annualpremium',
            },
            {
              key: 'termpremium',
              title: 'Term Premium',
              dataIndex: 'termpremium',
            },
          ]),
        // {
        //   key: 'itempstartdate',
        //   title: 'Start Date',
        //   dataIndex: 'itempstartdate',
        //   render: (text, record) => {
        //     return moment(text).format('DD-MM-YYYY')
        //   },
        // },
        {
          title: 'Action',
          dataIndex: 'operation',
          render: (_, record) =>
            this.state.data.length >= 1 ? (
              <>
                <Tooltip title="Edit">
                  <button
                    className="edit_btn"
                    onClick={() => this.EditRecord(record.key)}>
                    <EditOutlined />
                  </button>
                </Tooltip>
                <Popconfirm
                  title="Do you want to remove this Item ?"
                  onConfirm={() => this.handleDelete(record.key)}>
                  <Button type="danger" style={{ marginLeft: 8 }}>
                    <DeleteOutlined />
                  </Button>
                </Popconfirm>
              </>
            ) : // <button onClick={(e) => { this.handleDelete(record.key, e); }}><DeleteOutlined/></button>

              null,
        },
      ],
      columnsForFCP: [
        {
          key: 'relation',
          title: 'Relationship',
          dataIndex: 'relationship',
        },
        {
          key: 'policy_cover',
          title: 'Policy Cover',
          dataIndex: 'policy_cover',
        },
        {
          key: 'riskitem_name',
          title: 'Risk Item',
          dataIndex: 'riskitemname',
        },
        {
          key: 'name',
          title: 'Members Name',
          dataIndex: 'membername',
        },
        {
          key: 'gender',
          title: 'Gender',
          dataIndex: 'gender',
        },
        {
          key: 'age',
          title: 'Age',
          dataIndex: 'age',
        },

        ...(parseInt(localStorage.getItem('productId')) === 3
          ? [
            {
              key: 'sumInsured',
              title: 'Sum Insured',
              dataIndex: 'suminsured',
              hidden: true,
            },
            // {
            //   key: 'Proratapremium',
            //   title: 'Prorata Premium',
            //   dataIndex: 'prorata',
            // },
            {
              key: 'annualpremium',
              title: 'Annual Premium',
              dataIndex: 'annualpremium',
            },

            {
              key: 'termpremium',
              title: 'Term Premium',
              dataIndex: 'termpremium',
            },
          ]
          : [
            {
              key: 'sumInsured',
              title: 'Sum Insured',
              dataIndex: 'suminsured',
              hidden: true,
            },
            // {
            //   key: 'Proratapremium',
            //   title: 'Prorata Premium',
            //   dataIndex: 'prorata',
            // },
            {
              key: 'annualpremium',
              title: 'Annual Premium',
              dataIndex: 'annualpremium',
            },

            {
              key: 'termpremium',
              title: 'Term Premium',
              dataIndex: 'termpremium',
            },
          ]),

        {
          title: 'Action',
          dataIndex: 'operation',
          render: (_, record) =>
            this.state.dataForFCP.length >= 1 ? (
              <>
                <Tooltip title="Edit">
                  <button
                    className="edit_btn"
                    onClick={() => this.EditRecord(record.key)}>
                    <EditOutlined />
                  </button>
                </Tooltip>
                <Popconfirm
                  title="Do you want to remove this Item ?"
                  onConfirm={() => this.handleDeleteForFcp(record.key)}>
                  <Button type="danger" style={{ marginLeft: 8 }}>
                    <DeleteOutlined />
                  </Button>
                </Popconfirm>
              </>
            ) : // <button onClick={(e) => { this.handleDelete(record.key, e); }}><DeleteOutlined/></button>

              null,
        },
      ],
      ValidationColumns: [
        {
          title: 'Validation Errors',
          dataIndex: 'validationErrors',
          key: 'validationErrors',
          render: errors => (
            <ul style={{ paddingLeft: 20, margin: 0 }}>
              {errors.map((err, idx) => (
                <li style={{ fontSize: '15px', color: 'red' }} key={idx}>{err}</li>
              ))}
            </ul>
          ),
        },
      ],
    }
    // this.updateInput = this.updateInput.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.ShowHideCorporateName = this.ShowHideCorporateName.bind(this)
    this.setVisible = this.setVisible.bind(this)
    this.setVisibleFalse = this.setVisibleFalse.bind(this)
    this.hideModal = this.hideModal.bind(this)
    this.setVisibleSearch = this.setVisibleSearch.bind(this)
    this.riskitem = this.riskitem.bind(this)
    this.startdateChange = this.startdateChange.bind(this)
    this.enddateChange = this.enddateChange.bind(this)
    this.DobDateChange = this.DobDateChange.bind(this)
    this.paymenttermChange = this.paymenttermChange.bind(this)
    this.riskcoverChange = this.riskcoverChange.bind(this)
    this.findDayDifference = this.findDayDifference.bind(this)
    this.startdateChangeRiskItem = this.startdateChangeRiskItem.bind(this)
    this.CoverTypeChange = this.CoverTypeChange.bind(this)
    this.currencyChange = this.currencyChange.bind(this)
    this.DobFcp = this.DobFcp.bind(this)
    this.textInput = React.createRef()
    this.RoleChange = this.RoleChange.bind(this)
  }
  handleFormChange = e => {
    this.setState({ selectedForm: e.target.value })
  }

  applyMinimumPremium = (annualPremium, termPremium) => {
    // ensure minimumPremium is a number and default to 100
    const minPremium = Number(this.state.minimumPremium) || 100;

    // force numeric and round input premiums first
    //const safeAnnual = isNaN(Number(annualPremium)) ? 0 : roundvalue(Number(annualPremium));
    const safeTerm = isNaN(Number(termPremium)) ? 0 : roundvalue(Number(termPremium));

    // Only apply minimum if there is an actual computed value (>0).
    //const appliedAnnualPremium = safeAnnual > 0 ? Math.max(safeAnnual, minPremium) : 0;
    const appliedTermPremium = safeTerm > 0 ? Math.max(safeTerm, minPremium) : 0;

    // keep user-visible note if anything was bumped
    const overrideNote =
      (safeTerm > 0 && safeTerm < minPremium)
        ? `Applied minimum premium $${minPremium}`
        : '';

    this.setState({ overrideNotes: overrideNote });

    // return rounded applied values
    return {
      appliedAnnualPremium: roundvalue(annualPremium),
      appliedTermPremium: roundvalue(appliedTermPremium),
    };
  };

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.data !== this.state.data ||
      prevState.taxes !== this.state.taxes ||
      prevState.annualPremiumTotal !== this.state.annualPremiumTotal ||
      prevState.termPremiumTotal !== this.state.termPremiumTotal
    ) {
      this.updateGrandTotals();
    }
  }




  updateGrandTotals = () => {
    const totals = this.state.data.reduce(
      (acc, item) => {
        acc.prorata += Number(item.prorata || 0);
        acc.annualpremium += Number(item.annualpremium || 0);
        acc.termpremium += Number(item.termpremium || 0);
        acc.suminsured += Number(item.suminsured || 0);
        return acc;
      },
      { prorata: 0, annualpremium: 0, termpremium: 0, suminsured: 0 }
    );

    this.setState({ footerTotals: totals });

    const productName = (localStorage.getItem("productName") || "").toLowerCase();
    const isMotor = productName.includes("motor");

    const taxAmounts = this.state.taxes
      .filter(tax => {
        if (tax.taxName.toLowerCase().includes("government levy")) {
          if (!isMotor) return false;
          if (this.state.entitytype === "Individual") {
            return tax.taxName.toLowerCase().includes("private");
          } else if (this.state.entitytype === "Business") {
            return tax.taxName.toLowerCase().includes("commercial");
          }
          return false;
        }
        return true;
      })
      .map(tax => {
        let amounts;
        if (isMotor && (tax.taxName.toLowerCase().includes("private") || tax.taxName.toLowerCase().includes("commercial"))) {
          const months = Number(this.state.paymentterm) || 12;
          const prorated = (tax.ratePercentage / 12) * months;
          const levyValue = Math.max(prorated, 2);

          amounts = {
            prorata: 0,
            annualpremium: tax.ratePercentage,
            termpremium: levyValue,
          };
        } else if (tax.taxName.toLowerCase().includes("stamp duty")) {
          amounts = {
            annualpremium: Math.min(totals.annualpremium * (tax.ratePercentage / 100), 100000),
            termpremium: Math.min(totals.termpremium * (tax.ratePercentage / 100), 100000),
          };
        } else {
          amounts = {
            annualpremium: totals.annualpremium * (tax.ratePercentage / 100),
            termpremium: totals.termpremium * (tax.ratePercentage / 100),
          };
        }
        return { ...tax, amounts };
      });

    const grandTotals = {
      annualpremium: totals.annualpremium + taxAmounts.reduce((sum, t) => sum + t.amounts.annualpremium, 0),
      termpremium: totals.termpremium + taxAmounts.reduce((sum, t) => sum + t.amounts.termpremium, 0),
      prorata: totals.prorata,
    };


    this.setState({ grandTotals });
    this.setState({ totalSumInsured: totals.suminsured });
  };



  EditRecord = async index => {
    this.state.hasEdited = true
    const record = this.state.data[index]
    await this.riskcoverChange(record.policy_cover_id)

    await this.riskitem(parseInt(record.riskitemid));
    // debugger
    this.props.form.setFieldsValue({
      riskItem: Number(record.riskitemid),
      policyCover: record.policy_cover_id,
      address: record.address,
      rate: parseFloat(record.rate).toFixed(2),
      sumInsured: record.suminsured,
      itempstartdate: moment(record.itempstartdate, this.state.dateFormat),
      relation: record?.relationship,
      name: record?.membername,
      VehicleRegistration: this.state?.VehicleRegistration,
      Make: this.state?.Make,
      Model: this.state?.Model,
      Year: this.state?.Year,
    })

    this.setState({
      policyCoverValue: record.policy_cover_id,
      rate: record.rate,
      sumInsuredValue: record.suminsured,
      DObValue: moment(record?.dateofbirth),
      relationValue: record?.relationship,
      ageFcp: record?.age,
      genderValue: record?.gender,
      VehicleRegistration: this.state?.VehicleRegistration,
      Make: this.state?.Make,
      Model: this.state?.Model,
      Year: this.state?.Year,
      editingRecordId: record.key,
    })
  }

  handleEditSubmit = e => {
    e.preventDefault();
    debugger;
    this.props.form.validateFields(async (err, values) => {
      if (err) {
        this.showAllErrorMessages(err);
        return;
      }
      if (!err) {
        try {
          debugger
          // Get the edited record from state
          const editedRecord = this.state.data.find(item =>
            item.key === this.state.editingRecordId
          );

          if (!editedRecord) {
            message.error('Record not found for editing');
            return;
          }

          // Calculate dates
          const startDate = new Date(this.state.riskItemStartDate);
          const endDate = new Date(this.state.policyEndDate);

          const Noofdays = this.findDayDifference(startDate, endDate);

          // Calculate premiums
          let annualpremium = roundvalue(
            (values.sumInsured / 100) * this.state.rate
          );

          let termpremium = 0;
          // if (this.state.monthlyTermPayment) {
          //   termpremium =
          //     ((values.sumInsured / 100) * this.state.rate) /
          //     parseInt(this.state.policyDuration);
          // } else {
          // Your existing term premium calculation logic
          if (this.state.paymentterm == 3) {
            termpremium = (annualpremium / 4).toFixed(2);
          } else if (this.state.paymentterm == 4) {
            termpremium = (annualpremium / 3).toFixed(2);
          } else if (this.state.paymentterm == 6) {
            termpremium = (annualpremium / 2).toFixed(2);
          } else if (this.state.paymentterm == 12) {
            termpremium = (annualpremium).toFixed(2);
          }
          // }


          const minPremium = Number(this.state.minimumPremium || 0);

          if (termpremium < minPremium) {
            termpremium = minPremium;
            message.success(`Minimum premium of $${minPremium} applied`);
          };

          const overrideNote = (annualpremium < minPremium || termpremium < minPremium)
            ? `Applied minimum premium $${minPremium}`
            : '';
          this.setState({ overrideNotes: overrideNote });


          const prorata = roundvalue(
            (values.sumInsured / 100) * this.state.rate * (Noofdays / 365)
          );

          // Format dates
          const riskstartdate = new Date(this.state.riskItemStartDate);
          const riskenddate = new Date(this.state.policyEndDate);

          // Create updated risk item
          const updatedRiskItem = {
            ...editedRecord, // Keep existing properties
            address: values.address,
            suminsured: values.sumInsured,
            rate: this.state.rate,
            annualpremium,
            termpremium,
            prorata,
            policy_cover_id: this.state.riskCover,
            riskitemid: this.state.riskitemid.toString(),
            riskitemname: this.state.riskitemfortable,
            itempstartdate: riskstartdate.toGMTString(), // Format as needed
            itempenddate: riskenddate.toGMTString(), // Format as needed
            monthlypremium: productNameInLocalStorage === 'LEGAL INSURANCE' ? this.state.rate : 0,
          };

          // Update the data array
          const updatedData = this.state.data.map(item =>
            item.key === updatedRiskItem.key ? updatedRiskItem : item
          );

          // Recalculate totals
          let totalMonthlyPremium = 0;
          let annual_premium = 0;
          let term_premium = 0;
          let pro_rata = 0;
          let TotalSumInsured = 0;

          updatedData.forEach(item => {
            pro_rata += item.prorata;
            annual_premium += item.annualpremium;
            term_premium += item.termpremium;
            totalMonthlyPremium += parseInt(item.monthlypremium);
            TotalSumInsured += parseInt(item.suminsured);
          });
          // Update state
          this.setState({
            data: updatedData,
            monthlyTotalPayment: totalMonthlyPremium,
            prorataPremiumTotalForEdit: pro_rata,
            annualPremiumTotalForEdit: annual_premium,
            termPremiumTotalForEdit: term_premium,
            prorataPremiumTotal: roundvalue(pro_rata),
            annualPremiumTotal: roundvalue(annual_premium),
            termPremiumTotal: roundvalue(term_premium),
            editingRecordId: null, // Clear editing state
            TotalSumInsured: TotalSumInsured,
          });

          // Reset form fields
          this.props.form.resetFields([
            'policyCover',
            'riskItem',
            'address',
            'sumInsured',
          ]);

          this.setState({
            riskItemValue: 'Select',
            policyCoverValue: 'Select',
            monthlyPaymentValues: 0,
            addressValue: '',
            sumInsuredValue: 0,
            rate: 0,
            Minimum_rate: 0,
          });

          this.updateGrandTotals();

          message.success('Risk item updated successfully!');

        } catch (error) {
          console.error('Error updating risk item:', error);
          message.error('Failed to update risk item');
          if (err && err.response && err.response.data && err.response.data.message) {
            message.error('Failed to update risk item: ' + err.response.data.message);
          } else {
            message.error('Failed to update risk item');
          }

        }
      }
    });
  };

  handleDelete = key => {
    this.state.totalSumInsured = this.state.totalSumInsured - key.suminsured
    const dataSource = [...this.state.data]
    const filterdata = dataSource.filter(item => item.key !== key)
    this.setState({
      data: dataSource.filter(item => item.key !== key),
    })

    let termPremium_Total = 0
    let annualPremium_Total = 0
    let prorataPremium_Total = 0
    let monthlyTotalPayment = 0
    for (let i = 0; i < filterdata.length; i++) {
      this.state.isTableViible = 'hidden'
      termPremium_Total += filterdata[i].termpremium
      annualPremium_Total += filterdata[i].annualpremium
      prorataPremium_Total += filterdata[i].prorata
      monthlyTotalPayment =
        parseFloat(monthlyTotalPayment) +
        parseFloat(filterdata[i].monthlyPayment)
    }
    this.setState({ termPremiumTotal: termPremium_Total })
    this.setState({ annualPremiumTotal: annualPremium_Total })
    this.setState({ prorataPremiumTotal: prorataPremium_Total })
    this.setState({
      monthlypremium: parseInt(monthlyTotalPayment),
      monthlyTotalPayment: monthlyTotalPayment,
    })
  }
  custDetail = async () => {
    try {
      const response = await apiRequest(
        `${process.env.REACT_APP_BASE_CUST}/Customers/GetCustDetails/`,
        'GET',
      )
      if (response.success) {
        this.setState({ CustomerDetails1: response.data })
      } else {
        console.error('API Error:', response.error)
      }
    } catch (error) {
      console.error('Request failed:', error)
    }
  }

  handleSearch = e => {
    const query = e.target.value
    const { CustomerDetails1 } = this.state
    const filtered = CustomerDetails1.filter(customer =>
      customer.customerName.toLowerCase().includes(query.toLowerCase()),
    )
    // console.log('filtered', filtered)

    // console.log(filtered+" "+query)
    this.setState({ searchQuery: query, filteredCustomers: filtered })
  }

  getInsurers = async () => {
    try {
      const response = await apiRequest(
        `${process.env.REACT_APP_BASE_URL_INSURER}/api/Insurer/GetInsurersWithAllowedBrokersByProduct/` +
        this.state.productId,
        'GET',
      )
      if (response.success) {
        this.setState({ insurerList: response.data })
      } else {
        console.error('API Error:', response.error)
      }
    } catch (error) {
      console.error('Request failed:', error)
    }
  }

  insurerChange = async (value, option) => {
    const insurerEmail = option.props['data-email']
    this.setState({ selectedInsurer: value, insurerEmail: insurerEmail })
    try {
      const response = await apiRequest(
        `${process.env.REACT_APP_BASE_URL_INSURER}/api/Insurer/GetInsurerProductByInsurerIdProductId?productId=${this.state.productId}&insurerId=${value}`,
        'GET',
      )
      debugger;
      if (response.success) {
        this.setState({ specificProductID: response?.data.insurerProduct?.id })
        this.setState({
          reinsuranceLimit: response?.data.insurerProduct?.maxLimit,
        })
        this.setState({ minimumPremium: response?.data.insurerProduct?.minimumPremium })
      } else {
        console.error('API Error:', response.error)
      }
    } catch (error) {
      console.error('Request failed:', error)
    }

    this.fetchCurrenciesByInsurer(value);

    this.fetchTaxesByInsurer(value);
    apiRequest(
      `${process.env.REACT_APP_BASE_URL_INSURER}/api/Insurer/GetRiskCoversByInsurerProductId/${this.state.specificProductID}`,
      'GET',
    )
      .then(response => {
        console.log(response)
        if (response.success && response.data) {
          const data = response.data

          this.setState({
            riskCoverDrop: data,
          })
        } else {
          console.error('API Error:', response.error)
        }
      })
      .catch(error => console.error('Error fetching Cover list:', error))
  }

  fetchTaxesByInsurer = async (insurerId) => {
    try {
      const res = await apiRequest(
        `${process.env.REACT_APP_BASE_URL_INSURER}/api/Insurer/GetStampByInsurerId/${insurerId}`,
        "GET"
      );

      const taxes = res?.data || [];

      if (taxes.length === 0) {
        this.setState({ taxes: [] });
        message.error("No tax data found for the selected insurer.");
        return;
      }
      const selectedProductId =
        parseInt(localStorage.getItem("selectedProductId")) ||
        parseInt(this.state.productId) ||
        0; // default 0 means 'All'

      //  Normalize backend property name (some APIs send lowercase)
      const normalizedTaxes = taxes.map((tax) => ({
        ...tax,
        specificProductId:
          tax.specificProductId !== undefined
            ? tax.specificProductId
            : tax.SpecificProductId,
      }));


      const filteredTaxes = normalizedTaxes.filter(
        (tax) =>
          tax.specificProductId === 0 ||
          tax.specificProductId === selectedProductId
      );


      const finalTaxes = filteredTaxes.length > 0 ? filteredTaxes : normalizedTaxes;

      this.setState({ taxes: finalTaxes });
    } catch (err) {
      console.error("Error fetching taxes:", err);
      this.setState({ taxes: [] });
    }
  };


  fetchCurrenciesByInsurer = async (insurerId) => {
    try {
      const res = await apiRequest(
        `${process.env.REACT_APP_BASE_URL_ADMIN}/Product/GetCurrenciesByInsurer/GetCurrency/${insurerId}`,
        'GET'
      );
      const currencies = res?.data?.data || [];
      this.setState({ currencyList: currencies });

      if (currencies.length === 0) {
        this.props.form.setFieldsValue({ currency: undefined });
        this.setState({ currencyDisabled: true });
      } else {
        this.setState({ currencyDisabled: false });
      }
    } catch (err) {
      this.setState({ currencyList: [] });
      this.props.form.setFieldsValue({ currency: undefined });
      this.setState({ currencyDisabled: true });
    }
  };

  componentDidMount() {
    // Calculate policy end date
    const { policyStartDate } = this.state
    const datestring = policyStartDate
    const year = new Date(datestring).getFullYear()
    const month = new Date(datestring).getMonth()
    const day = new Date(datestring).getDate()
    const newDate = new Date(year + 1, month, day - 1)

    this.getInsurers()

    this.setState({ policyEndDate: newDate }, this.printenddate)
    this.custDetail()

    this.fetchRoles()

    if (this.state.quotationsNumberParams) {
      this.search(this.state.quotationsNumberParams)
    }
  }

  handleDeleteForFcp = key => {
    const dataSource = [...this.state.dataForFCP]
    const filterdataForFcp = dataSource.filter(item => item.key !== key)
    this.setState({
      dataForFCP: dataSource.filter(item => item.key !== key),
    })
    let monthlyPremiumTotal = 0
    let sumInsuredTotal = 0
    for (let i = 0; i < filterdataForFcp.length; i++) {
      monthlyPremiumTotal += filterdataForFcp[i].monthlypremium
      sumInsuredTotal += filterdataForFcp[i].suminsured
    }
    this.setState({
      sumInsuredTotalFCP: roundvalue(sumInsuredTotal),
    })
    this.setState({
      monthlyPremiumTotal: roundvalue(
        (monthlyPremiumTotal / 100) * this.state.stampDuty,
      ),
    })
    this.setState({
      prorataPremiumTotal: roundvalue(
        (monthlyPremiumTotal / 100) * this.state.stampDuty,
      ),
    })
    // console.log(monthlyPremiumTotal)
    // console.log(sumInsuredTotal)
  }
  handleInputChange = e => {
    // Update the state with the input value
    this.setState({ nationalid: e.target.value }, () => {

      let nationalInputValue = this.state.nationalid
      console.log('Updated nationalid:', nationalInputValue)
    })
  }



  handleStateUpdate = () => {

    console.log('Updated state: ++ Updated state:', this.state.nationalid10)
  }

  handleToastConfirmation = userConfirmed => {
    toast.dismiss()

    if (userConfirmed) {

      this.setState({ clickYes: true })


      this.setState({ loading: false })
    } else {

      console.log("User clicked 'No'")
      this.setState({ loading: false })
    }
  }

  fetchRoles = async () => {
    this.setState({ loading: true })
    try {
      const response = await apiRequest(
        process.env.REACT_APP_BASE_URL_AUTH + '/api/Auth/child-roles',
        'GET',
      )
      if (response.success) {
        this.setState({ RoleList: response.data }) // Store roles
      } else {
        toast.error('Failed to fetch roles', {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 5000,
        })
      }
    } catch (error) {
      console.error('Error fetching roles', error)
    } finally {
      this.setState({ loading: false })
    }
  }

  RoleChange(value) {
    this.setState({ RoleId: value })
  }
  calculatePremiums = (annualPremium, termPremium, paymentTerm, isMonthlyDeduction) => {

    if (paymentTerm != 12) {
      // Spread annual premium across payment terms
      return roundvalue(termPremium / paymentTerm);
    } else {
      // If not monthly, the full annual premium is the term premium
      return roundvalue(annualPremium / 12);
    }
  };



  submitpolicy = async e => {
    debugger;
    e.preventDefault();
    const { data, dataForFCP } = this.state;
    const disableAddFieldValidation =
      (Array.isArray(data) && data.length > 0) ||
      (Array.isArray(dataForFCP) && dataForFCP.length > 0);

    this.setState({ disableAddFieldValidation }, () => {
      this.props.form.validateFields(async (err, values) => {
        if (err) {
          this.showAllErrorMessages(err);
          return;
        }
        if (!err) {
          this.setState({ loading: true });

          if ((this.state.productId === 3 || this.state.productId === 5) && dataForFCP.length === 0) {
            message.error('Please add at least one risk item.');
            this.setState({ loading: false });
            return;
          }

          if (!(this.state.productId === 3 || this.state.productId === 5) && data.length === 0) {
            message.error('Please add at least one risk item.');
            this.setState({ loading: false });
            return;
          }

          let apiurl = `${process.env.REACT_APP_BASE_URL}/quotation/AddClientwithQuotation`;

          const customer_name =
            this.state.entitytype === 'Business'
              ? values.corporateName
              : `${values.firstName} ${values.surName}`;

          const customerDetails = {
            id: 0,
            modifiedby: 1,
            entitytype: this.state.entitytype,
            nationalid: values.uuid || '',
            clientfirstname: values.firstName || '',
            clientsurname: values.surName || '',
            clientcorporatename: values.corporateName || '',
            clientemailaddress: values.emailAddress,
            clientage: parseInt(values.age) || 0,
            clientgender: values.gender || '',
            clientaddress1: values.address1 || '',
            clientaddress2: '',
            suburb: values.suburb || '',
            city: values.city || '',
            clientcontactnumber: values.contactNumber || '',
            createdby: this.state.loggedInId,
          };

          // // --- Calculate Grand Totals ---
          // let grandAnnualTotal = 0;
          // let grandTermTotal = 0;
          // let grandProrataTotal = 0;
          // let grandMonthlyTotal = 0;

          const riskItems = this.state.productId === 3 || this.state.productId === 5 ? dataForFCP : data;

          // riskItems.forEach(item => {
          //   const sumInsured = parseFloat(item.suminsured) || 0;
          //   const rate = parseFloat(item.rate) || 0;
          //   const paymentTerm = parseInt(this.state.paymentterm) || 12;

          //   // Annual Premium
          //   const annualPremium = (sumInsured * rate) / 100;
          //   // Term Premium
          //   const termPremium = this.state.monthlyTermPayment
          //     ? annualPremium / (parseInt(this.state.policyDuration) || 12)
          //     : annualPremium / paymentTerm;

          //   // No of days for prorata
          //   let noOfDays = this.findDayDifference(
          //     new Date(this.state.riskItemStartDate),
          //     new Date(this.state.policyEndDate)
          //   );
          //   noOfDays = noOfDays + 1; // include both start & end dates

          //   const prorata = (annualPremium * noOfDays) / 365;

          //   // Monthly Payment
          //   const monthlyPayment =
          //     this.state.monthlyPaymentInLegalAid && productNameInLocalStorage === 'LEGAL INSURANCE'
          //       ? parseFloat(this.state.monthlyPaymentInLegalAid)
          //       : 0;

          //   // Add to Grand Totals
          //   grandAnnualTotal += annualPremium;
          //   grandTermTotal += termPremium;
          //   grandProrataTotal += prorata;
          //   grandMonthlyTotal += monthlyPayment;
          // });


          // --- Calculate Stamp Duty Values ---
          const stampdutyannualpremium = roundvalue(
            this.state.grandTotals.annualpremium - this.state.footerTotals.annualpremium
          );
          const stampdutytermpremium = roundvalue(
            this.state.grandTotals.termpremium - this.state.footerTotals.termpremium
          );

debugger;

          // --- Prepare product details object ---
          const productDetails = {
            clientid: 0,
            createdby: localStorage.getItem('loggedInUserID'),
            customername: customer_name,
            customeremail: values.emailAddress,
            modifiedby: 1,
            productname: this.state.productName || '',
            riskitemList: this.state.data.map(item => ({
              ...item,
              stampdutytermpremium: (roundvalue(
                this.state.grandTotals.termpremium - this.state.footerTotals.termpremium
              )).toString(),
              monthlypremium: roundvalue(
                this.calculatePremiums(
                  this.state.grandTotals.annualpremium,
                  this.state.grandTotals.termpremium,
                  12,
                  this.state.isMonthlyDeduction
                )
              ),
            })),

            isactive: true,
            isdeleted: false,
            policyriskcover: this.state.policyriskcover,
            policystartdate: new Date(this.state.policyStartDate).toGMTString(),
            policyexpirytdate: new Date(this.state.policyEndDate).toGMTString(),

            // Base totals
            totalannualpremium: roundvalue(this.state.footerTotals.annualpremium),
            totaltermpremium: roundvalue(this.state.footerTotals.termpremium),
            proratatotaltermpremium: roundvalue(0),

            // Add stamp duty
            stampdutyannualpremium,
            stampdutytermpremium,

            // Grand totals
            grandtotalannualpremium: roundvalue(this.state.grandTotals.annualpremium),
            grandtotaltermpremium: roundvalue(this.state.grandTotals.termpremium),
            grandtotalmonthlypremium: roundvalue(0),

            isMonthlyDeduction: this.state.isMonthlyDeduction,
            monthlyTermPayment: this.calculatePremiums(
              roundvalue(this.state.grandTotals.annualpremium),
              roundvalue(this.state.grandTotals.termpremium),
              parseInt(this.state.paymentterm),
              this.state.isMonthlyDeduction
            ),
            paymentterms: this.state.paymentterm,
            customerid: this.state.customerid,
            currency: this.state.currency,
            reinsurancelimit: this.state.reinsuranceLimit,
            TotalSumInsured: this.state.totalSumInsured,
            productGenId: this.state.genericProductId,
            productid: parseInt(this.state.specificProductID),
            riskcoverid: parseInt(this.state.riskcoverid),
            id: 0,
            reinsurancelimit: this.state.reinsuranceLimit,
            ownretention: 0,
            risklocation1: '',
            risklocation2: '',
            risksuburb: '',
            riskcity: '',
            buildingusage: '',
            risksecurityfeatures: '',
            riskbuildingmaterial: '',
            riskowner: '',
            quotationstatus: '',
            createdbyname: '',
            modifiedbyname: '',
            quotationnumber: '',
            BrokerId: localStorage.getItem('loggedInUserID'),
            InsurerId: this.state.selectedInsurer || 0,
            nationalid: values.uuid || '',

            // Motor-specific
            ...(this.state.policyriskcover.toLowerCase().includes('motor') ||
              this.state.policyriskcover.toLowerCase().includes('vehicle') ||
              this.state.productName.toLowerCase().includes('motor')
              ? {
                VehicleRegistration: this.state.VehicleRegistration || '',
                Make: this.state.Make || '',
                Model: this.state.Model || '',
                Year: this.state.Year || '',
              }
              : {}),

            // Additional defaults
            productid: parseInt(this.state.specificProductID) || 0,
            riskcoverid: parseInt(this.state.riskcoverid) || 0,
            customerid: this.state.customerid || 0,
          };
debugger;
          // --- Email request object ---
          const LoginUserData = this.state.UserDetail;
          const emailRequest = {
            customerDetail: {
              customerId: customerDetails?.id,
              notifyCustomer: values.emailAddress,
            },
            insurerDetail: {
              insurerId: this.state.selectedInsurer,
              notifyInsurer: this.state.insurerEmail,
            },
            brokerDetail: {
              brokerId: LoginUserData?.UserId,
              notifyBroker: LoginUserData?.email,
              brokerRole: LoginUserData?.role,
            },
          };
          productDetails.emailRequest = JSON.stringify(emailRequest);

          const totalData = {
            clientdetail: customerDetails,
            pquotationdetail: productDetails,
          };

          try {
            const result = await apiRequest(apiurl, 'POST', totalData);
            if (result.success && result.data.status === true) {
              this.setState({ loading: false });
              message.success('Quotation created successfully !!');
            } else {
              message.error('Quotation could not be created !!');
            }
            window.location.href = '/quotations';
            this.setState({ loading: false });
          } catch (error) {
            console.error('Error ---', error);
            this.setState({ loading: false });
          }
        }
      });
    });
  };

  hideModal() {
    this.setState({
      visibleSearch: false,
    })
  }

  CoverTypeChange(value) {
    this.setState({ coverType: value })
  }

  setVisibleSearch() {
    this.setState({
      visibleSearch: false,
    })
    this.setState({ visible: true })
  }

  setVisible() {
    this.setState({ visible: true })
  }
  setVisibleFalse() {
    this.setState({ visible: false })
  }
  ShowHideCorporateName(value) {
    console.log('ShowHideCorporateName ' + value)
    this.setState({ entitytype: value })
    if (value === 'Business') this.setState({ isRequired: false })
    else this.setState({ isRequired: true })
  }

  showAllErrorMessages = (errorObj) => {

    if (!errorObj || typeof errorObj !== 'object') return;

    const errorEntries = Object.entries(errorObj);

    errorEntries.forEach(([fieldName, fieldData], index) => {
      const errors = fieldData?.errors;
      if (Array.isArray(errors)) {
        errors.forEach((err, errIndex) => {
          const delay = 3000 * (index + errIndex);
          setTimeout(() => {
            if (err?.message) {
              message.error(err.message);
            }
          }, delay);
        });
      }
    });
  };

  handleChange = async val => {
    try {
      const response = await apiRequest(
        `${process.env.REACT_APP_BASE_CUST}/Customers/GetCustDetailsByID/${val}`,
        'GET',
      )

      if (response.success && response.data) {
        const data = response.data
        console.log('Fetched customer data', data)

        // this.props.form.resetFields();

        this.setState({
          clientfirstname: data.customerName,
          clientsurname: data.customerSurname,
          clientcorporatename: data.corporateName,
          clientcontactnumber: data.mobile,
          clientemailaddress: data.emailAddress,
          clientemailDob: data?.clientemailDob,
          clientgender: data.gender,
          clientage: data.age,
          clientaddress1: data.address,
          customerid: data.id,
          nationalid: data.nationalID,
          suburb: data.suburb,
          city: data.city,
          entitytype: data.entityType,
          baseData: [],
        })

        this.props.form.setFieldsValue({
          gender: data.gender,
          firstName: data.customerName,
          surName: data.customerSurname,
          corporateName: data.corporateName,
          contactNumber: data.mobile,
          emailAddress: data.emailAddress,
          uuid: data.nationalID,
          address1: data.address,
          suburb: data.suburb,
          city: data.city,
          age: data.age,
        })
      } else {
        console.error('API Error:', response.error)
      }
    } catch (error) {
      console.error('Error fetching data:', error)
    }
  }
  //  get value of monthly payment  according to policy cover
  monthlyPaymentValue = value => {
    // debugger
    if (/premier/.test(value.toLowerCase())) {
      return '6.00'
    } else if (/bronze/.test(value.toLowerCase())) {
      return '11.00'
    } else if (/diamond/.test(value.toLowerCase())) {
      return '25.00'
    } else if (/platinum/.test(value.toLowerCase())) {
      return '35.00'
    } else {
      return '0'
    }
  }
  riskitem(value) {
    // debugger
    this.setState({ cellphone: false })
    this.state.addressifNotBuilding = '--'
    for (let i = 0; i < this.state.riskItemList.length; i++) {
      if (value === this.state.riskItemList[i].riskItemId) {
        this.setState({ riskitemid: this.state.riskItemList[i].riskItemId })
        this.setState({ Minimum_rate: this.state.riskItemList[i].ratePercentage })
        let riskitemName = this.state.riskItemList[i].riskItemName
        this.setState({
          riskitemfortable: this.state.riskItemList[i].riskItemName,
        })
        // get monthly payment value
        let monthlyPayment = this.monthlyPaymentValue(riskitemName)
        // this.props.form.setFieldsValue({ monthlyPaymentInLegalAid:"" ,monthlyPayment: '' })}
        //this.setState({monthlyPaymentInLegalAid:0 , monthlyPayment:0})
        if (productNameInLocalStorage === 'LEGAL INSURANCE') {
          this.setState({
            monthlyPaymentInLegalAid: monthlyPayment,
            monthlyPayment: parseInt(monthlyPayment),
            rate: parseFloat(monthlyPayment).toFixed(2),
          })
          this.myRef.current.value = monthlyPayment
        }
        this.state.coverType = 'Sum Insured'

      }
      this.setState({ riskItemValue: value })
    }
  }

  findDayDifference(date1, date2) {
    // always round down
    return Math.floor(Math.abs(date2 - date1) / (1000 * 60 * 60 * 24))
  }



  handleSubmit = e => {
    debugger;
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (err) {
        this.showAllErrorMessages(err);
        return;
      }
      const premiumRate = this.state.rate / 100;
      const annualPremium = values.sumInsured * premiumRate;

      let termPremium = 0;
      if (this.state.paymentterm == 3) {
        termPremium = (annualPremium / 4).toFixed(2);
      } else if (this.state.paymentterm == 4) {
        termPremium = (annualPremium / 3).toFixed(2);
      } else if (this.state.paymentterm == 6) {
        termPremium = (annualPremium / 2).toFixed(2);
      } else if (this.state.paymentterm == 12) {
        termPremium = (annualPremium).toFixed(2);
      }

      const minPremium = Number(this.state.minimumPremium || 0);

      if (termPremium < minPremium) {
        termPremium = minPremium;
        message.success(`Minimum premium of $${minPremium} applied`);
      };

      let noOfDays = this.findDayDifference(
        new Date(this.state.riskItemStartDate),
        new Date(this.state.policyEndDate)
      );
      noOfDays = noOfDays + 1; // include both dates

      const prorata = (annualPremium * noOfDays) / 365;

      // --- Step 4: Monthly Payment (if applicable) ---
      const monthlyPayment =
        this.state.monthlyPaymentInLegalAid && productNameInLocalStorage === "LEGAL INSURANCE"
          ? parseFloat(this.state.monthlyPaymentInLegalAid)
          : 0;


      const newProduct = {
        key: this.state.count,
        riskitemid: this.state.riskitemid?.toString(),
        policy_cover: this.state.policyriskcover,
        policy_cover_id: this.state.riskcoverid,
        riskitemname: this.state.riskitemfortable,
        covertype: this.state.coverType,
        address: values.address || "",
        suminsured: roundvalue(values.sumInsured),
        rate: this.state.rate,
        prorata: roundvalue(prorata),
        annualpremium: roundvalue(annualPremium),
        termpremium: roundvalue(termPremium),
        monthlyPayment: roundvalue(monthlyPayment),
        itempstartdate: new Date(this.state.riskItemStartDate).toGMTString(),
        itempexpirydate: new Date(this.state.policyEndDate).toGMTString(),
        id: 0,
        membername: "",
        gender: "",
        age: "",
        premiumfactor: 0,
        relationship: "",
        grand_total: 0,
        policynumber: "",
        policyquotatonid: 0,
      };
      // --- Special case for Legal Insurance ---
      if (productNameInLocalStorage === "LEGAL INSURANCE") {
        Object.assign(newProduct, {
          annualpremium: 0,
          termpremium: 0,
          prorata: 0,
          suminsured: 0,
        });
      }
      // --- Add product to data list ---
      const updatedData = [...this.state.data, newProduct];

      // --- Step 5: Calculate Grand Totals ---
      const grandAnnualTotal = updatedData.reduce((sum, item) => sum + item.annualpremium, 0);
      const grandTermTotal = updatedData.reduce((sum, item) => sum + item.termpremium, 0);
      const grandProrataTotal = updatedData.reduce((sum, item) => sum + item.prorata, 0);
      const grandMonthlyTotal = updatedData.reduce(
        (sum, item) => sum + parseFloat(item.monthlyPayment || 0),
        0
      );

      // --- Update State ---
      this.setState({
        data: updatedData,
        count: this.state.count + 1,
        grandAnnualTotal: roundvalue(grandAnnualTotal),
        grandTermTotal: roundvalue(grandTermTotal),
        grandProrataTotal: roundvalue(grandProrataTotal),
        grandMonthlyTotal: roundvalue(grandMonthlyTotal),
        // Reset form-related states
        riskItemValue: "Select",
        policyCoverValue: "Select",
        monthlyPaymentValues: 0,
        addressValue: "",
        rate: 0,
        sumInsuredValue: "",
      });

      this.props.form.setFieldsValue({
        policyCover: undefined,
        riskItem: undefined,
        sumInsured: "",
        address: "",
        rate: 0.0,
      });
    });
  };


  // -------------- get value of Risk Item Value  according to policy cover------------------
  handleSubmitForFCP = e => {
    debugger;
    e.preventDefault()
    this.props.form.validateFields((err, values) => {
      if (err) {
        this.showAllErrorMessages(err);
        return;
      }
      if (!err) {
        const currentSumInsured = parseFloat(values.sumInsured || 0)
        const updatedTotal = this.state.totalSumInsured + currentSumInsured

        const riskstartdate = new Date(this.state.riskItemStartDate)
        var riskenddate = new Date(this.state.policyEndDate)
        const rate = parseFloat(this.state.rate)
        let monthly_pre = 0

        if (values.sumInsured > 0) {
          const sum_insured = values.sumInsured / 1000
          monthly_pre = parseFloat((sum_insured * rate).toFixed(2))
        } else {
          monthly_pre = rate
        }

        if (updatedTotal > this.state.reinsuranceLimit) {
          message.error('Total Sum Insured exceeds reinsurance limit')
          return
        }

        // if (currentSumInsured > this.state.reinsuranceLimit) {
        //   message.error('Sum Insured exceeds reinsurance limit')
        //   return
        // }
        let term_premium = '0.0'
        let prorata = '0.0'
        let annual_premium = (values.sumInsured / 100) * this.state.rate
        var Noofdays = this.findDayDifference(
          new Date(this.state.riskItemStartDate),
          new Date(this.state.policyEndDate),
        )
        Noofdays = Noofdays + 1
        prorata = ((values.sumInsured / 100) * this.state.rate * Noofdays) / 365
        if (this.state.monthlyTermPayment) {
          term_premium = ((values.sumInsured / 100) * this.state.rate) / parseInt(this.state.policyDuration)
        } else {
          if (this.state.paymentterm == 3) {
            term_premium = ((values.sumInsured / 100) * this.state.rate) / 4
          } else if (this.state.paymentterm == 4) {
            term_premium = ((values.sumInsured / 100) * this.state.rate) / 3
          } else if (this.state.paymentterm == 6) {
            term_premium = ((values.sumInsured / 100) * this.state.rate) / 2
          } else if (this.state.paymentterm == 12) {
            term_premium = (values.sumInsured / 100) * this.state.rate
          }
        }
        const { appliedAnnualPremium, appliedTermPremium } = this.applyMinimumPremium(annual_premium, term_premium);
        const newProduct = {
          key: this.state.count,
          riskitemid: this.state.riskitemid.toString(),
          riskitemname: this.state.riskitemfortable,
          rate: rate.toFixed(2),
          gender: values.genderFcp,
          membername: values.name,
          relationship: values.relation,
          suminsured: values.sumInsured > 0 ? parseInt(values.sumInsured) : 0,
          premiumfactor:
            (values.sumInsured > 0 ? parseInt(values.sumInsured) : 0) / 1000,
          monthlypremium: monthly_pre,
          age: this.state.ageFcp,
          policyquotatonid: 0,
          itempstartdate: riskstartdate,
          // `${riskstartdate.getFullYear()}-${riskstartdate.getMonth() + 1
          // }-${riskstartdate.getDate()}`,
          itempexpirydate: riskenddate,
          policy_cover: this.state.policyriskcover,
          policy_cover_id: this.state.riskcoverid,
          id: 0,
          address: '',
          policynumber: '',
          itempexpirydate: '',
          grand_total: 0,
          dateofbirth: this.state.clientDob,
          prorata: roundvalue(prorata),
          annualpremium: roundvalue(appliedAnnualPremium),
          termpremium: roundvalue(appliedTermPremium),
        }

        const updatedDataForFCP = [...this.state.dataForFCP, newProduct]

        this.setState(
          prevState => ({
            dataForFCP: updatedDataForFCP,
            newProductForFCP: newProduct,
            count: prevState.count + 1,
            totalSumInsured: updatedTotal,
            isTableViible: 'hidden',
            riskItemValue: 'Select',
            policyCoverValue: 'Select',
            monthlyPaymentValues: 0,
            addressValue: '',
            clientDob: null,
            DObValue: null,
            ageFcp: null,
            relationValue: 'Select',
            relationship: 'Select',
            // rate: 0,
            // sumInsuredValue: '',
            Minimum_rate: 0,
          }),
          () => {
            if (updatedDataForFCP.length) {
              let prorataTotal = 0
              let termTotal = 0
              let annualTotal = 0
              let monthlyTotal = 0

              updatedDataForFCP.forEach(item => {
                prorataTotal += item.prorata
                termTotal += item.termpremium
                annualTotal += item.annualpremium
                monthlyTotal += parseFloat(item.monthlyPayment)
              })

              this.setState({
                prorataPremiumTotal: prorataTotal,
                termPremiumTotal: termTotal,
                annualPremiumTotal: annualTotal,
                monthlyTotalPayment: monthlyTotal,
              })
            }
          },
        )
        this.props.form.setFieldsValue({
          policyCover: undefined,
          riskItem: undefined,
          sumInsured: '',
          address: '',
          rate: 0.0,
        })
      }
    })
  }

  // Helper functions inside your class
  toNumber(value) {
    const num = parseFloat(value);
    return isNaN(num) ? 0 : num;
  }

  // Converts "10%" or "0.1" to a decimal for backend
  parseRate(rateStr) {
    if (!rateStr) return 0;
    let cleaned = rateStr.toString().replace("%", "").trim();
    let number = parseFloat(cleaned);
    return isNaN(number) ? 0 : number / 100;
  }

  // Format Excel date to ISO string
  formatExcelDate(value) {
    if (!value) return '';
    if (value instanceof Date) {
      const yyyy = value.getFullYear();
      const mm = String(value.getMonth() + 1).padStart(2, '0');
      const dd = String(value.getDate()).padStart(2, '0');
      return `${yyyy}-${mm}-${dd}T00:00:00`;
    }
    return value.toString();
  }

  parsePercentage = async value => {
    if (!value) return 0;
    return parseFloat(value.toString().replace('%', '').trim());
  }

  // Main Excel upload handler
  handleExcelUpload = async file => {
    this.setState({ loading: true });

    const reader = new FileReader();
    reader.onload = async e => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: 'array' });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];

      const jsonData = XLSX.utils.sheet_to_json(worksheet, { defval: '', header: 0, raw: false, cellDates: true });
      const transformedPayload = jsonData.map(row => {
        const paymentTerm = parseInt(row['Payment Term']) || 12;
        const dayDiff = this.findDayDifference(
          new Date(row['Start Date']),
          new Date(row['End Date'])
        );

        // Policy 1
        const sumInsured = this.toNumber(row['Sum Insured']);
        const rate = parseFloat(row['Rate'].toString().replace('%', '').trim());


        const annualPremium = roundvalue(
          (sumInsured / 100) * rate,
        );
        const prorata = roundvalue(
          (sumInsured / 100) * rate * (dayDiff / 365),
        )

        let termPremium = 0
        if (this.state.monthlyTermPayment) {
          termPremium =
            ((sumInsured / 100) * rate) /
            parseInt(this.state.policyDuration)
        } else {
          if (paymentTerm == 3) {
            termPremium = ((sumInsured / 100) * rate) / 4
          } else if (paymentTerm == 4) {
            termPremium = ((sumInsured / 100) * rate) / 3
          } else if (paymentTerm == 6) {
            termPremium = ((sumInsured / 100) * rate) / 2
          } else if (paymentTerm == 12) {
            termPremium = (sumInsured / 100) * rate
          }
        }
        termPremium = roundvalue(termPremium);
        const { appliedAnnualPremium, appliedTermPremium } =
          this.applyMinimumPremium(annualPremium, termPremium);

        // ================= Policy 2 =================
        const sumInsured2 = this.toNumber(row['Sum Insured2']);
        const rate2 = this.parseRate(row['Rate2']);
        let annualPremium2 = 0,
          prorata2 = 0,
          appliedAnnualPremium2 = 0,
          appliedTermPremium2 = 0;

        if (sumInsured2 > 0 && rate2 > 0) {
          annualPremium2 = sumInsured2 * rate2;
          prorata2 = (annualPremium2 * dayDiff) / 365;
          const termPremium2Raw = annualPremium2 / paymentTerm;

          ({ appliedAnnualPremium: appliedAnnualPremium2, appliedTermPremium: appliedTermPremium2 } =
            this.applyMinimumPremium(annualPremium2, termPremium2Raw));
        }

        // ================= Policy 3 =================
        const sumInsured3 = this.toNumber(row['Sum Insured3']);
        const rate3 = this.parseRate(row['Rate3']);
        let annualPremium3 = 0,
          prorata3 = 0,
          appliedAnnualPremium3 = 0,
          appliedTermPremium3 = 0;

        if (sumInsured3 > 0 && rate3 > 0) {
          annualPremium3 = sumInsured3 * rate3;
          prorata3 = (annualPremium3 * dayDiff) / 365;
          const termPremium3Raw = annualPremium3 / paymentTerm;

          ({ appliedAnnualPremium: appliedAnnualPremium3, appliedTermPremium: appliedTermPremium3 } =
            this.applyMinimumPremium(annualPremium3, termPremium3Raw));
        }


        // ================= Totals =================
        const totalannualpremium = appliedAnnualPremium + appliedAnnualPremium2 + appliedAnnualPremium3;
        const proratatotaltermpremium = prorata + prorata2 + prorata3;
        const totaltermpremium = appliedTermPremium + appliedTermPremium2 + appliedTermPremium3;

        const stampdutyannualpremium = this.toNumber(
          ((totalannualpremium / 100) * this.state.stampDuty).toFixed(2)
        );
        const stampdutytermpremium = this.toNumber(
          ((proratatotaltermpremium / 100) * this.state.stampDuty).toFixed(2)
        );

        const grandtotalannualpremium = this.toNumber(
          (totalannualpremium + stampdutyannualpremium).toFixed(2)
        );
        const grandtotaltermpremium = this.toNumber(totaltermpremium);

        return {
          // General Info
          EntityType: row['Entity Type'] || '',
          FullName: row['Full Name'] || '',
          ContactNumber: (row['Contact Number'] || '').toString(),
          EmailAddress: row['Email Address'] || '',
          Age: parseInt(row['Age']) || 0,
          Address: row['Address'] || '',
          NationalId: row['National Id'] || '',
          Suburb: row['Suburb'] || '',
          Gender: row['Gender'] || '',
          City: row['City'] || '',
          InsurerList: row['Insurer List'] || '',
          StartDate: this.formatExcelDate(row['Start Date']),
          EndDate: this.formatExcelDate(row['End Date']),
          PaymentTerm: paymentTerm.toString(),
          Currency: row['Currency'] || '',

          // Policy 1
          PolicyCover: row['Policy Cover'] || '',
          RiskItem: row['Risk Item'] || '',
          SumInsured: sumInsured,
          Rate: rate,
          annualPremium: this.toNumber(appliedAnnualPremium),
          prorata: this.toNumber(prorata),
          termPremium: this.toNumber(appliedTermPremium),

          // Policy 2
          PolicyCover2: row['Policy Cover2'] || '',
          RiskItem2: row['Risk Item2'] || '',
          SumInsured2: sumInsured2,
          Rate2: rate2,
          annualPremium2: this.toNumber(appliedAnnualPremium2),
          prorata2: this.toNumber(prorata2),
          termPremium2: this.toNumber(appliedTermPremium2),
          // Policy 3
          PolicyCover3: row['Policy Cover3'] || '',
          RiskItem3: row['Risk Item3'] || '',
          SumInsured3: sumInsured3,
          Rate3: rate3,
          annualPremium3: this.toNumber(appliedAnnualPremium3),
          prorata3: this.toNumber(prorata3),
          termPremium3: this.toNumber(appliedTermPremium3),

          // Vehicle & Product
          VehicleRegisteration: row['Vehicle Registration'] || '',
          Make: row['Make'] || '',
          Model: row['Model'] || '',
          Year: parseInt(row['Year']) || 0,
          brokerId: parseInt(localStorage.getItem('loggedInUserID')),
          productname: this.state.productName,
          productid: parseInt(this.state.productId),
          TotalSumInsured: this.state.totalSumInsured,
          productGenId: this.state.genericProductId,

          // Totals
          totalannualpremium: this.toNumber(totalannualpremium),
          grandtotalannualpremium: this.toNumber(grandtotalannualpremium),
          totaltermpremium: this.toNumber(totaltermpremium),
          grandtotaltermpremium: this.toNumber(grandtotaltermpremium),
          proratatotaltermpremium: this.toNumber(proratatotaltermpremium),
          stampdutyannualpremium: this.toNumber(stampdutyannualpremium),
          stampdutytermpremium: this.toNumber(stampdutytermpremium),

        };
      });

      try {
        const response = await apiRequest(
          `${process.env.REACT_APP_BASE_URL}/quotation/ValidateQuotationDetails/validateQuotation`,
          'POST',
          transformedPayload
        );

        this.setState({
          validExcelRecords: response?.data?.validRecords || [],
          invalidExcelRecords: response?.data?.invalidRecords || [],
          loading: false,
        });
      } catch (err) {
        console.error('Validation API error:', err);
      } finally {
        this.setState({ loading: false });
      }
    };

    reader.readAsArrayBuffer(file);
    return false;
  };

  handleDownloadSample = async () => {
    try {
      const response = await fetch(
        process.env.REACT_APP_BASE_URL +
        '/quotation/GetExcel_QuotationBulkUploadTemplate?productId=' +
        this.state.productId,
        {
          method: 'GET',
          headers: {
            // Add any required headers (e.g., Authorization)
            Authorization: `Bearer ${this.state.token}`,
          },
        },
      )
      if (!response.ok) throw new Error('File download failed')

      const blob = await response.blob()
      const url = window.URL.createObjectURL(blob)

      const a = document.createElement('a')
      a.href = url

      // Optional: extract filename from Content-Disposition header
      const contentDisposition = response.headers.get('content-disposition')
      let filename = 'downloaded-file'
      if (contentDisposition && contentDisposition.includes('filename=')) {
        filename = contentDisposition
          .split('filename=')[1]
          .replace(/"/g, '')
          .trim()
      }

      a.download = filename
      document.body.appendChild(a)
      a.click()

      // Clean up
      a.remove()
      window.URL.revokeObjectURL(url)
    } catch (err) {
      console.error('Error downloading file:', err)
    }
  }

  async submitExslQuotation(validRecords) {
    // debugger
    console.log(validRecords)
    let customerEmail = null
    for (const record of validRecords) {
      let newCustomerId = null

      // 2. Always prepare and submit quotation
      try {
        const quotationData = {
          pquotationdetail: record.pquotationdetail,
          clientdetail: record.clientdetail,
        }

        const quotationResponse = await apiRequest(
          `${process.env.REACT_APP_BASE_URL}/quotation/AddClientwithQuotation`,
          'POST',
          quotationData,
        )

        if (quotationResponse.success) {
          console.log(
            `Quotation created successfully for ${quotationData.customername}`,
          )
        } else {
          console.error(
            `Quotation creation failed for ${quotationData.customername}`,
          )
        }
      } catch (error) {
        console.error('Quotation API error:', error)
      }
    }
    window.location.href = '/quotations'
  }

  getRisKItemValueBasedOnPolicyCover = () => {
    if (this.state.policyriskcover == 'Premier') {
      return '6.00'
    } else if (this.state.policyriskcover == 'Bronze') {
      return '11.00'
    } else if (this.state.policyriskcover == 'Diamond') {
      return '25.00'
    } else if (this.state.policyriskcover == 'Platinum') {
      return '35.00'
    } else {
      return '0'
    }
  }

  convertDateToString() { }

  getRiskCoverName = val => {
    const { riskCoverDrop } = this.state
    // console.log('need to check something',riskCoverDrop);
    const cover = riskCoverDrop.find(item => item.riskCoverId === val)
    return cover ? cover.riskCoverName : null
  }

  //function to get riskcover multiple selection
  riskcoverChange = async value => {
    // console.log('need data from here',value);
    // debugger
    if (value !== 'Select Value') {
      // console.log(value)
      this.setState({ policyriskcover: value.toString() })
      try {
        const response = await apiRequest(
          `${process.env.REACT_APP_BASE_URL_INSURER}/api/Insurer/GetRiskItemsByCoverId/${value}/${this.state.selectedInsurer}`,
          'GET',
        )
        if (response.success == false) {
          this.setState({
            riskItemList: [],
          })
        }
        debugger

        if (response.success && response.data.length > 0) {
          const data = response.data
          const selectedCoverName = this.getRiskCoverName(value)

          this.setState({
            riskItemList: data,
            policyriskcover: selectedCoverName,
            riskcoverid: value,
          })
        }
      } catch (error) {
        console.error('Error fetching risk cover:', error)
      }
    }

    this.setState({ policyCoverValue: value })
  }

  startdateChangeRiskItem(date, datestring) {
    if (datestring === '') {
      message.warning('Risk item start date cannot be null')
    } else {
      if (new Date(this.state.policyEndDate) < new Date(datestring)) {
        message.error('Invalid Date')
      } else {
        this.setState({ riskItemStartDate: new Date(datestring) })
      }
    }
  }

  DobFcp(date, datestring) {
    this.setState({ DObValue: datestring })
    if (this.state.policyriskcover.length > 0) {
      var a = moment(new Date())
      var b = moment(date)
      var daysOld = a.diff(b, 'days')
      var monthsOld = a.diff(b, 'months')
      var yearsOld = a.diff(b, 'years') // 1

      var agesuffix =
        yearsOld === 1
          ? 'year'
          : yearsOld > 1
            ? 'years'
            : monthsOld === 1
              ? 'month'
              : monthsOld > 1
                ? 'months'
                : daysOld === 1
                  ? 'day'
                  : 'days'
      if (yearsOld > 0) {
        this.setState({ ageFcp: yearsOld.toString() + ' ' + agesuffix })
      } else if (monthsOld > 0) {
        this.setState({ ageFcp: monthsOld.toString() + ' ' + agesuffix })
      } else {
        this.setState({ ageFcp: daysOld.toString() + ' ' + agesuffix })
      }
      for (let i = 0; i < this.state.riskItemList.length; i++) {
        var rname = this.state.riskItemList[i].riskItemName
        var range = rname.replace(/[^\d.]/g, '')
        var Range1 = 0
        var Range2 = 0
        if (range.length > 3) {
          Range1 = parseInt(range.substring(0, 2))
          Range2 = parseInt(range.slice(-2))
        } else if (range.length === 3) {
          Range1 = parseInt(range.substring(0, 1))
          Range2 = parseInt(range.slice(-2))
          if (yearsOld === 0) {
            this.setState({ rate: this.state.riskItemList[i].ratepercentage })
          }
        }
        if (yearsOld > 0 && range.length > 3) {
          if (yearsOld <= Range2 && yearsOld >= Range1) {
            this.setState({ rate: this.state.riskItemList[i].ratepercentage })
          } else if (yearsOld > 80) {
            this.setState({ rate: [] })
          }
        }
      }
    } else {
      datestring = null
      message.warning('Please select Policy Cover')
    }
  }

  startdateChange(date, datestring) {
    if (datestring === '') {
      message.warning('Start date cannot be empty')
    } else if (new Date(datestring) >= new Date(this.state.currentDate)) {
      this.setState({ policyStartDate: new Date(datestring) });
      this.setState({ riskItemStartDate: new Date(datestring) });
      const dataRecords = this.state.data;

      if (dataRecords.length > 0) {
        this.SetRisKItemDataByStartDate(datestring)
      }
    } else {
      message.warning('Start date cannot be smaller than Current Date')
    }
  }

  enddateChange(date, datestring) {
    let end_date = new Date(datestring)
    if (datestring === '') {
      message.warning('End date cannot be empty')
    } else {
      if (end_date > this.state.policyStartDate) {
        this.setState({ policyEndDate: datestring })
      } else {
        message.error('Invalid Duration ')
      }
    }

  }

  DobDateChange(date, datestring) {
    //  let end_date = new Date(datestring)
    if (datestring === '') {
      message.warning(' date cannot be empty')
    } else {
      this.setState({ clientDob: datestring })
    }
  }
  validateDate() {
    if (Date(this.state.policyEndDate) < Date(this.state.policyStartDate)) {
    }
  }

  SetRisKItemDataByStartDate(datestring) {
    let term_premium = '0.0'
    let prorata = '0.0'

    var Noofdays = this.findDayDifference(
      new Date(datestring),
      new Date(this.state.policyEndDate),
    )
    Noofdays = Noofdays + 1

    let ctprorataPremiumTotal = 0
    let cttermPremiumTotal = 0
    let ctannualPremiumTotal = 0

    for (let i = 0; i < this.state.data.length; i++) {
      this.state.data[i].annualpremium = roundvalue(
        (this.state.data[i].rate / 100) * this.state.data[i].suminsured,
      )
      this.state.data[i].termpremium = roundvalue(
        ((this.state.data[i].rate / 100) * this.state.data[i].suminsured) / 3,
      )

      this.state.data[i].prorata = roundvalue(
        (((this.state.data[i].suminsured * this.state.data[i].rate) / 100) *
          Noofdays) /
        365,
      )
    }

    for (let i = 0; i < this.state.data.length; i++) {
      ctprorataPremiumTotal = this.state.data[i].prorata + ctprorataPremiumTotal
      cttermPremiumTotal = this.state.data[i].termpremium + cttermPremiumTotal
      ctannualPremiumTotal =
        this.state.data[i].annualpremium + ctannualPremiumTotal
    }

    this.setState({ prorataPremiumTotal: ctprorataPremiumTotal })
    this.setState({ termPremiumTotal: cttermPremiumTotal })
    this.setState({ annualPremiumTotal: ctannualPremiumTotal })
  }

  SetRisKItemDataByEndDate(datestring) {
    let term_premium = '0.0'
    let prorata = '0.0'

    var Noofdays = this.findDayDifference(
      new Date(this.state.policyStartDate),
      new Date(datestring),
    )
    Noofdays = Noofdays + 1

    let ctprorataPremiumTotal = 0
    let cttermPremiumTotal = 0
    let ctannualPremiumTotal = 0

    this.setState({ policyEndDate: datestring })

    for (let i = 0; i < this.state.data.length; i++) {

      let annualpremium = roundvalue(
        (this.state.data[i].rate / 100) * this.state.data[i].suminsured,
      )
      let termpremium = roundvalue(
        ((this.state.data[i].rate / 100) * this.state.data[i].suminsured) / 3,
      )


      const minPremium = Number(this.state.minimumPremium || 0)
      //if (annualpremium < minPremium) annualpremium = minPremium
      if (termpremium < minPremium) termpremium = minPremium

      const overrideNote =
        termpremium < minPremium
          ? `Applied minimum premium $${minPremium}`
          : ''
      this.setState({ overrideNotes: overrideNote })

      this.state.data[i].annualpremium = annualpremium
      this.state.data[i].termpremium = termpremium

      this.state.data[i].prorata = roundvalue(
        (((this.state.data[i].suminsured * this.state.data[i].rate) / 100) *
          Noofdays) /
        365,
      )
    }

    //  Totals
    for (let i = 0; i < this.state.data.length; i++) {
      ctprorataPremiumTotal = this.state.data[i].prorata + ctprorataPremiumTotal
      cttermPremiumTotal = this.state.data[i].termpremium + cttermPremiumTotal
      ctannualPremiumTotal =
        this.state.data[i].annualpremium + ctannualPremiumTotal
    }

    this.setState({
      prorataPremiumTotal: ctprorataPremiumTotal,
      termPremiumTotal: cttermPremiumTotal,
      annualPremiumTotal: ctannualPremiumTotal,
    })
  }

  currencyChange(value) {
    this.setState({ currency: value })
  }
  paymenttermChange(value) {
    //  select paymentterm john
    var monthsToBeAdded = parseInt(this.state.policyDuration)
    this.setState({ paymentterm: value })
    var year = new Date(this.state.policyStartDate).getFullYear()
    var month =
      new Date(this.state.policyStartDate).getMonth() + monthsToBeAdded
    var day = new Date(this.state.policyStartDate).getDate()
    var Newdate = new Date(year, month, day)
    this.setState({ policyEndDate: Newdate })
  }

  // Search functionality
  search = value => {
    // console.log(this.state.CustomerDetails1);

    const filterTable = this.state.CustomerDetails1.filter(o =>
      String(o.customerName).toLowerCase().includes(value.toLowerCase()),
    )
    // console.log(filterTable)
    console.log('filterTable', filterTable)

    this.setState({ filteredCustomers: filterTable })

    // if (value !== null || value !== ''){
    //   this.setState({baseData: filterTable})
    // }

    // else this.setState({baseData: []})
  }

  // handle change

  // handleChange=()=>{

  // }

  //+++++++++++++++++
  render() {
    const { getFieldDecorator } = this.props.form

    const {
      CustomerDetails1,
      searchQuery,
      filteredCustomers,
      customerName15,
      clickYes,
      productId,
      selectedForm,
    } = this.state


    const options = this.state.baseData.map(d => (
      <Select.Option key={d.client_id_number}>
        {d.client_name} {d.client_surname}
      </Select.Option>
    ))

    let RoleData =
      this.state.RoleList?.length > 0 &&
      this.state.RoleList?.map((item, i) => {
        return (
          <Select.Option key={i} value={item?.id}>
            {item?.roleName}
          </Select.Option>
        )
      }, this)

    let customerData =
      this.state.customerData.length > 0 &&
      this.state.customerData.map(d => (
        <Option key={d.value}>{d.client_id_number}</Option>
      ))

    let riskCoverList =
      this.state.riskCoverDrop.length > 0 &&
      this.state.riskCoverDrop.map((item, i) => {
        return (
          //<Select.Option   key={i} value={item.riskcoverid}>{item.riskname}</Select.Option>
          <Select.Option key={i} value={item.riskCoverId}>
            {item.riskCoverName}
          </Select.Option>
        )
      }, this)
    const paymenttermList = [3, 4, 6, 12].map(term => (
      <Select.Option key={term} value={term.toString()}>
        {term}
      </Select.Option>
    ))

    let riskNameList =
      this.state.riskItemList.length > 0 &&
      this.state.riskItemList.map((item, i) => {
        return (
          <Select.Option key={i} value={item.riskItemId}>
            {item.riskItemName}
          </Select.Option>
        )
      }, this)

    // console.log('risk names to display',riskNameList);
    let currencyList =
      this.state.currencyList.length > 0 &&
      this.state.currencyList.map((item, i) => {
        return (
          <Select.Option key={i} value={item.currencycode}>
            {item.currencyname + '-' + item.currencycode}
          </Select.Option>
        )
      }, this)
    //   console.log("ref is here" + this.myRef.current.value);
    let InsuranceList =
      this.state.insurerList.length > 0 &&
      this.state.insurerList.map((item, i) => {
        return (
          <Select.Option key={item.id} value={item.id}>
            {item?.name}
          </Select.Option>
        )
      }, this)
    return (
      <Layout className="dashboard">
        <Spin
          className="loader-icon-fixed"
          spinning={this.state.loading}
          size="large"></Spin>
        <div className=" dash-bg-white">
          <Row gutter={4}>
            <Col xs={12} sm={24} md={12} lg={12}>
              <h5
                style={{
                  color: '#F15A2B',
                  fontWeight: '500',
                  fontSize: '20px',
                  marginBottom: '0',
                }}>
                <strong>
                  Product Name :{' '}
                  <label
                    style={{
                      color: '#F15A2B',
                      fontWeight: '700',
                      fontSize: '20px',
                    }}>
                    {this.state.productName}
                  </label>
                </strong>
              </h5>
              {/* <Button
                size="default"
                value={"update"}
                onClick={this.submitpolicy}
                style={{
                  marginLeft: "auto",
                  color: "#fd7e14",
                  borderColor: "#fd7e14",                 
                }}>
                  
                Finalise
              </Button> */}
            </Col>
            <Col xs={12} sm={24} md={12} lg={12} style={{ textAlign: 'right' }}>
              <span style={{ color: '#ff4d4f', fontSize: '14px' }}>
                * indicates mandatory fields
              </span>
            </Col>
          </Row>
        </div>
        {productId === 10 && (
          <div className=" dash-bg-white">
            <Row gutter={[16, 16]}>
              <Col xs={24} sm={24} md={12}>
                <Card
                  title={
                    <span>
                      <FileTextOutlined
                        style={{ marginRight: 8, color: '#1890ff' }}
                      />
                      Bulk Upload
                    </span>
                  }
                  bordered
                  bodyStyle={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: 120,
                  }}
                  style={{
                    borderRadius: '12px',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                    cursor: 'pointer',
                    border:
                      this.state.selectedForm === 'form1'
                        ? '2px solid #1890ff'
                        : '1px solid #f0f0f0',
                  }}
                  onClick={() => this.setState({ selectedForm: 'form1' })}>
                  <Radio checked={this.state.selectedForm === 'form1'}>
                    Select Bulk Upload
                  </Radio>
                </Card>
              </Col>

              <Col xs={24} sm={24} md={12}>
                <Card
                  title={
                    <span>
                      <FileTextOutlined
                        style={{ marginRight: 8, color: '#1890ff' }}
                      />
                      Add manually
                    </span>
                  }
                  bordered
                  bodyStyle={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: 120,
                  }}
                  style={{
                    borderRadius: '12px',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                    cursor: 'pointer',
                    border:
                      this.state.selectedForm === 'form2'
                        ? '2px solid #1890ff'
                        : '1px solid #f0f0f0',
                  }}
                  onClick={() => this.setState({ selectedForm: 'form2' })}>
                  <Radio checked={this.state.selectedForm === 'form2'}>
                    Select Add manually
                  </Radio>
                </Card>
              </Col>
            </Row>
          </div>
        )}
        {selectedForm === 'form1' && productId === 10 && (
          <>
            <div className="dash-bg-white">
              <div style={{ marginTop: 20 }}>
                <Spin
                  spinning={this.state.loading}
                  size="large"
                  className="loader-icon-fixed"></Spin>

                <Row gutter={[24, 24]} justify="center">
                  {/* Upload Section */}
                  <Col xs={24} sm={24} md={12}>
                    <Card
                      title={
                        <span>
                          <FileExcelOutlined
                            style={{ marginRight: 8, color: '#52c41a' }}
                          />
                          Upload Filled Excel File
                        </span>
                      }
                      bordered
                      bodyStyle={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: 120,
                      }}
                      style={{
                        borderRadius: '12px',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                      }}>
                      <Upload {...this.uploadProps}>
                        <Button type="primary" size="middle">
                          <CloudUploadOutlined /> Click to Upload
                        </Button>
                      </Upload>

                      {/* Optional: show parsed data */}
                      {/* <pre>{JSON.stringify(this.state.excelData, null, 2)}</pre> */}
                    </Card>
                  </Col>

                  {/* Download Section */}
                  <Col xs={24} sm={24} md={12}>
                    <Card
                      title={
                        <span>
                          <DownloadOutlined
                            style={{ marginRight: 8, color: '#52c41a' }}
                          />
                          Download Bulk Upload Template
                        </span>
                      }
                      bordered
                      bodyStyle={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: 120,
                      }}
                      style={{
                        borderRadius: '12px',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                      }}>
                      <Button
                        type="primary"
                        size="middle"
                        onClick={this.handleDownloadSample}>
                        <CloudDownloadOutlined /> Download Template
                      </Button>
                    </Card>
                  </Col>
                  {this.state.validExcelRecords?.length > 0 && (
                    <Button
                      type="button"
                      onClick={() =>
                        this.submitExslQuotation(this.state.validExcelRecords)
                      }>
                      Submit
                    </Button>
                  )}
                </Row>
              </div>
            </div>
            {this.state.invalidExcelRecords.length >= 1 && (
              <div className="dash-bg-white">
                <Table
                  className="table-scroll-auto large-font-table"
                  columns={this.state.ValidationColumns}
                  dataSource={this.state.invalidExcelRecords}
                  rowKey={(record, index) => index}
                  bordered
                  pagination={false}
                  style={{ fontSize: '20px' }}
                />
              </div>
            )}
          </>
        )}
        {selectedForm === 'form2' && (
          <>
            <div className="dash-bg-white ">
              <Row gutter={[16, 16]}>
                <Col xs={12} sm={24} md={24} lg={16}>
                  <div className="section-top-heading">
                    <h3
                      style={{
                        color: '#F15A2B',
                        fontWeight: '700',
                        fontSize: '20px',
                        margin: '0',
                        marginBottom: '20px',
                      }}>
                      {' '}
                      Basic Customer Details{' '}
                    </h3>
                  </div>
                </Col>
                <Col xs={12} sm={24} md={24} lg={8}>
                  <div className="search-list">
                    <Form.Item>
                      {' '}
                      <Select
                        showSearch
                        value={this.state.value}
                        placeholder="Search Customer"
                        style={this.props.style}
                        defaultActiveFirstOption={false}
                        showArrow={false}
                        filterOption={false}
                        onSearch={this.search}
                        onChange={this.handleChange}
                        notFoundContent={null}>
                        {this.state.filteredCustomers.map(option => (
                          <Select.Option key={option.id} value={option.id}>
                            {option.customerName}
                          </Select.Option>
                        ))}
                      </Select>


                    </Form.Item>
                  </div>
                </Col>

              </Row>

              <div className="basic-customer-details">
                <Form onSubmit={this.handleSubmit}>
                  <Row gutter={[16, 16]}>
                    <Col xs={24} md={12} lg={4}>
                      <Form.Item label="Entity Type">
                        <Select
                          value={this.state.entitytype}
                          name="Entity type"
                          style={{ width: '100%' }}
                          onChange={e => {
                            this.ShowHideCorporateName(e)
                            this.setState({ isCustomerNew: true })
                          }}>
                          <Option selected value="">
                            --Select--
                          </Option>
                          <Option value="Business">Business</Option>
                          <Option value="Individual">Individual</Option>
                        </Select>
                      </Form.Item>
                    </Col>
                    {this.state.entitytype !== 'Business' &&
                      productNameInLocalStorage === 'LEGAL INSURANCE' && (
                        <Col xs={24} md={12} lg={4}>
                          <Form.Item label="Title">
                            {getFieldDecorator('title', {
                              rules: [
                                {
                                  required: true,
                                  message: 'Please enter title!',
                                  whitespace: false,
                                },
                              ],
                              initialValue: this.state.title,
                            })(
                              <Input
                                onChange={e =>
                                  this.setState({
                                    title: e.target.value,
                                    isCustomerNew: true,
                                  })
                                }
                              // placeholder="Enter Title"
                              />,
                            )}
                          </Form.Item>
                        </Col>
                      )}

                    {this.state.entitytype !== 'Business' && (
                      <Col xs={24} md={12} lg={4}>
                        <Form.Item label="First Name">
                          {getFieldDecorator('firstName', {
                            rules: [
                              {
                                required: true,
                                message: 'Please enter Firstname!',
                                whitespace: false,
                              },
                            ],

                            //initialValue:singleCustomer,
                            initialValue: this.state.clientfirstname,
                          })(
                            <Input
                              // placeholder="Enter Firstname"
                              onChange={e =>
                                this.setState({
                                  client: e.target.value,
                                  isCustomerNew: true,
                                })
                              }
                            />,
                          )}
                        </Form.Item>
                      </Col>
                    )}
                    {this.state.entitytype !== 'Business' && (
                      <Col xs={24} md={12} lg={4}>
                        <Form.Item label="Surname">
                          {getFieldDecorator('surName', {
                            rules: [
                              {
                                required: true,
                                message: 'Please enter Surname!',
                                whitespace: false,
                              },
                            ],
                            initialValue: this.state.clientsurname,
                          })(
                            <Input
                              // placeholder="Enter Surname"
                              onChange={e =>
                                this.setState({
                                  isCustomerNew: true,
                                })
                              }
                            />,
                          )}
                        </Form.Item>
                      </Col>
                    )}
                    {this.state.entitytype === 'Business' && (
                      <Col xs={24} md={12} lg={4}>
                        <Form.Item label="Corporate Name">
                          {getFieldDecorator('corporateName', {
                            rules: [
                              {
                                required: true,
                                message: 'Please enter Corporate Name!',
                                whitespace: false,
                              },
                            ],
                            initialValue: this.state.clientcorporatename,
                          })(
                            <Input
                              // placeholder="Enter Corporate Name"
                              onChange={e =>
                                this.setState({
                                  isCustomerNew: true,
                                })
                              }
                            />,
                          )}
                        </Form.Item>
                      </Col>
                    )}
                    <Col xs={24} md={12} lg={4}>
                      <Form.Item label="Contact Number">
                        {getFieldDecorator('contactNumber', {
                          rules: [
                            {
                              required: true,
                              message: 'Please enter Number!',
                              whitespace: false,
                            },
                            {
                              pattern: /^\d{10}$/,
                              message: 'Phone number must be 10 digits',
                            },
                          ],
                          initialValue: this.state.clientcontactnumber,
                        })(
                          <Input
                            // placeholder="Enter Contact Number"
                            maxLength={10}
                            onChange={e =>
                              this.setState({
                                isCustomerNew: true,
                              })
                            }
                          />,
                        )}
                      </Form.Item>
                    </Col>
                    <Col xs={24} md={12} lg={4}>
                      <Form.Item label="Email Address">
                        {getFieldDecorator('emailAddress', {
                          rules: [
                            {
                              required: true,
                              message: 'Please enter Email Address!',
                              whitespace: false,
                            },
                            {
                              type: 'email',
                              message: 'Please enter a valid Email Address!',
                            },
                          ],
                          initialValue: this.state.clientemailaddress,
                        })(
                          <Input
                            // placeholder="Enter Email Address"
                            onChange={e =>
                              this.setState({
                                isCustomerNew: true,
                              })
                            }
                          />,
                        )}
                      </Form.Item>
                    </Col>
                    {this.state.entitytype !== 'Business' &&
                      productNameInLocalStorage != 'LEGAL INSURANCE' && (
                        <Col xs={24} md={12} lg={4}>
                          <Form.Item label="Age">
                            {getFieldDecorator('age', {
                              rules: [
                                {
                                  required: true,
                                  message: 'Please enter Age',
                                },
                              ],
                              initialValue: this.state.clientage,
                            })(
                              <Input
                                // placeholder="Enter Age"
                                onChange={e =>
                                  this.setState({
                                    isCustomerNew: true,
                                  })
                                }
                              />,
                            )}
                          </Form.Item>
                        </Col>
                      )}
                    {this.state.entitytype !== 'Business' &&
                      productNameInLocalStorage === 'LEGAL INSURANCE' && (
                        <Col xs={24} md={12} lg={4}>
                          <Form.Item label="Date of birth">
                            <DatePicker
                              style={{ width: '100%' }}
                              // placeholder="Date of birth"
                              disabledDate={current =>
                                current.isAfter(moment().subtract(1, 'day')) ||
                                current.isBefore(moment().subtract(65, 'years'))
                              }
                              value={moment(
                                this.state.clientDob,
                                this.state.dateFormat,
                              )}
                              onChange={e => {
                                this.DobDateChange(e)
                                this.setState({
                                  isCustomerNew: true,
                                })
                              }}
                            />
                          </Form.Item>
                        </Col>
                      )}
                    <Col xs={24} md={12} lg={4}>
                      <Form.Item label="National Id">
                        {getFieldDecorator('uuid', {
                          rules: [
                            {
                              required: true,
                              message: 'Please enter National Id!',
                              whitespace: false,
                            },
                          ],
                          initialValue: this.state.nationalid,
                        })(
                          <Input
                            value={this.state.nationalid}
                            onChange={e => {
                              this.handleInputChange(e)
                              this.setState({
                                isCustomerNew: true,
                              })
                            }}
                          // placeholder="Enter National Id"
                          />,
                        )}
                      </Form.Item>
                    </Col>
                    {this.state.entitytype !== 'Business' && (
                      <Col xs={24} md={12} lg={4}>
                        <Form.Item label="Gender">
                          {getFieldDecorator('gender', {
                            initialValue: '',
                            rules: [
                              {
                                required: true,

                                message: 'Please input gender!',
                              },
                            ],
                          })(
                            <Select
                              value={this.state.clientgender}
                              onChange={e => {
                                this.setState({
                                  isCustomerNew: true,
                                })
                              }}>
                              <Option selected value="">
                                --Select--
                              </Option>
                              <Option value="Male">Male</Option>
                              <Option value="Female">Female</Option>
                            </Select>,
                          )}
                        </Form.Item>
                      </Col>
                    )}
                    <Col xs={24} md={12} lg={4}>
                      <Form.Item label="Address">
                        {getFieldDecorator('address1', {
                          rules: [
                            {
                              required: true,
                              message: 'Please enter Address !',
                              whitespace: false,
                            },
                          ],
                          initialValue: this.state.clientaddress1,
                        })(
                          <Input
                            // placeholder="Enter Address "
                            onChange={e => {
                              this.setState({
                                isCustomerNew: true,
                              })
                            }}
                          />,
                        )}
                      </Form.Item>
                    </Col>

                    <Col xs={24} md={12} lg={4}>
                      <Form.Item label="Suburb">
                        {getFieldDecorator('suburb', {
                          rules: [
                            {
                              required: true,
                              message: 'Please enter Suburb !',
                              whitespace: false,
                            },
                          ],
                          initialValue: this.state.suburb,
                        })(
                          <Input
                            // placeholder="Enter Suburb "
                            onChange={e => {
                              this.setState({
                                isCustomerNew: true,
                              })
                            }}
                          />,
                        )}
                      </Form.Item>
                    </Col>
                    <Col xs={24} md={12} lg={4}>
                      <Form.Item label="City">
                        {getFieldDecorator('city', {
                          rules: [
                            {
                              required: true,
                              message: 'Please enter City !',
                              whitespace: false,
                            },
                          ],
                          initialValue: this.state.city,
                        })(
                          <Input
                            // placeholder="Enter City"
                            onChange={e => {
                              this.setState({
                                isCustomerNew: true,
                              })
                            }}
                          />,
                        )}
                      </Form.Item>
                    </Col>
                    {/* <Col xs={24} md={12} lg={4}>
                      <Form.Item label="Role">
                        {getFieldDecorator('role', {
                          rules: [
                            {
                              required: true,
                              message: 'Please select a Role!',
                            },
                          ],
                        })(
                          <Select
                            placeholder="--Select option--"
                            onChange={this.RoleChange}
                            style={{ display: 'inline' }}>
                            {RoleData}
                          </Select>,
                        )}
                      </Form.Item>
                    </Col> */}
                  </Row>
                </Form>
              </div>
            </div>
            <div className="dash-bg-white">
              <h3
                style={{
                  color: '#F15A2B',
                  fontWeight: '700',
                  fontSize: '18px',
                  marginBottom: '20px',
                }}>
                Policy Details
              </h3>
              <Row gutter={[16, 24]}>
                <Col xs={24} md={12} lg={5}>
                  <Form.Item label="Insurer">
                    {getFieldDecorator('insurer', {
                      rules: [
                        {
                          required: true,
                          message: 'Please select an Insurer!',
                        },
                      ],
                    })(
                      <Select
                        placeholder="--Select option--"
                        onChange={this.insurerChange}
                        style={{ display: 'inline' }}>
                        {InsuranceList}
                      </Select>,
                    )}
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} lg={5}>
                  <Form.Item label="Policy Start Date">
                    <DatePicker
                      style={{ width: '100%' }}
                      // placeholder="Policy Start Date"
                      value={moment(
                        this.state.policyStartDate,
                        this.state.dateFormat,
                      )}
                      onChange={this.startdateChange}
                    />
                  </Form.Item>
                </Col>

                {/* {this.state.productId === 1 ||
              this.state.productId === 2 ||
              this.state.productId === 4 ? ( */}
                <Col xs={20} md={12} lg={5}>
                  <Form.Item label="Payment Term">
                    {getFieldDecorator('paymentTerm', {
                      rules: [
                        {
                          required: true,
                          message: 'Please select a Payment Term!',
                        },
                      ],
                    })(
                      <Select
                        placeholder="--Select option--"
                        onChange={this.paymenttermChange}
                        style={{ display: 'inline' }}>
                        {paymenttermList}
                      </Select>,
                    )}
                  </Form.Item>
                </Col>
                {/* {this.state.paymentterm === '12' && ( */}
                <Col xs={20} md={12} lg={4}>
                  <Form.Item label="Is Monthly Deduction">
                    <Checkbox
                      checked={this.state.isMonthlyDeduction}
                      onChange={e =>
                        this.setState({ isMonthlyDeduction: e.target.checked })
                      }
                      style={{ transform: 'scale(1.3)', marginLeft: '8px' }}
                    />
                  </Form.Item>
                </Col>
                {/* )} */}

                {/* ) : (
              ''
            )} */}

                {/* {(this.state.productId === 1 ||
                  this.state.productId === 2 ||
                  this.state.productId === 4) &&
                productNameInLocalStorage != 'LEGAL INSURANCE' ? ( */}
                <Col xs={24} md={12} lg={5}>
                  <Form.Item label="Policy End Date">
                    <DatePicker
                      style={{ width: '100%' }}
                      placeholder="Policy End Date"
                      value={moment(
                        this.state.policyEndDate,
                        this.state.dateFormat,
                      )}
                      // disabled
                      onChange={this.enddateChange}
                    />
                  </Form.Item>
                </Col>
                {/* ) : (
                  <Col xs={24} md={12} lg={5}>
                    <Form.Item label="Policy End Date">
                      <DatePicker
                        style={{width: '100%'}}
                        placeholder="Policy End Date"
                        value={moment(
                          this.state.policyEndDate,
                          this.state.dateFormat,
                        )}
                        disabled
                        onChange={this.enddateChange}
                      />
                    </Form.Item>
                  </Col>
                )} */}

                <Col xs={20} md={12} lg={4}>
                  <Form.Item label="Currency">
                    {getFieldDecorator('currency', {
                      rules: [{ required: true, message: 'Please select currency' }],
                    })(
                      <Select
                        // disabled={this.state.currencyDisabled}
                        allowClear
                        placeholder="Select currency"
                        disabled={this.state.currencyList.length === 0}
                        notFoundContent={this.state.currencyList.length === 0 ? 'No currencies available' : null}
                        onChange={value => {
                          this.setState({ currency: value }, () => {
                            // Recalculate USD value when currency changes
                            const { currencyRates, sumInsuredValue } = this.state;
                            const numericValue = Number(sumInsuredValue);
                            const selectedRateObj = currencyRates?.find(
                              rate => rate.currencyCode === value
                            );
                            const selectedRate = selectedRateObj?.rate || 1;
                            const usdRateObj = currencyRates?.find(
                              rate => rate.currencyCode === 'USD'
                            );
                            const usdRate = usdRateObj?.rate || 1;
                            let usdValue = '';
                            if (!isNaN(numericValue) && numericValue > 0) {
                              usdValue = ((numericValue / selectedRate) * usdRate).toFixed(2);
                            }
                            this.setState({ sumInsuredUSD: usdValue });
                          });
                        }}
                      >
                        {this.state.currencyList.map((item, i) => (
                          <Option key={item.currencyId} value={item.currencyName}>
                            {item.currencyName}
                          </Option>
                        ))}
                      </Select>
                    )}
                  </Form.Item>
                </Col>

                <Col xs={20} md={12} lg={5}>
                  <Form.Item label="Risk Insurance Limit">
                    <Input value={this.state.reinsuranceLimit} disabled />
                  </Form.Item>
                </Col>
              </Row>
            </div>

            <div className="dash-bg-white">
              <h3
                style={{
                  color: '#F15A2B',
                  fontWeight: '700',
                  fontSize: '18px',
                  marginBottom: '20px',
                }}>
                Product Details
              </h3>

              <Form
                onSubmit={
                  this.state.productId === 3 || this.state.productId === 5
                    ? this.handleSubmitForFCP
                    : this.handleSubmit
                }>
                <Row gutter={[16, 24]}>
                  <Col xs={20} md={12} lg={4}>
                    <Form.Item label="Policy Cover">
                      {getFieldDecorator('policyCover', {
                        rules: this.state.disableAddFieldValidation
                          ? []
                          : [
                            {
                              required: true,
                              message: 'Please select a Policy Cover!',
                            },
                          ],
                        // initialValue: this.state.policyCoverValue,
                      })(
                        <Select
                          id="policy_Cover"
                          placeholder="Select option"
                          onChange={this.riskcoverChange}
                          style={{ display: 'inline' }}>
                          {riskCoverList}
                        </Select>,
                      )}
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={12} lg={4}>
                    <Form.Item label="Risk Item">
                      {getFieldDecorator('riskItem', {
                        rules: this.state.disableAddFieldValidation
                          ? []
                          : [
                            {
                              required: true,
                              message: 'Please select a Risk Item!',
                            },
                          ],
                        // initialValue: this.state.riskItemValue,
                      })(
                        <Select
                          placeholder="Select"
                          onChange={this.riskitem}
                          style={{ display: 'inline' }}>
                          {riskNameList}
                        </Select>,
                      )}
                    </Form.Item>
                  </Col>

                  {this.state.productId === 3 || this.state.productId === 5 ? (
                    <Col xs={24} md={12} lg={4}>
                      <Form.Item label="Date of Birth">
                        <DatePicker
                          disabledDate={current =>
                            current.isAfter(moment().subtract(1, 'day')) ||
                            current.isBefore(moment().subtract(65, 'years'))
                          }
                          disabled={
                            this.state.policyriskcover.length > 0 ? false : true
                          }
                          onChange={this.DobFcp}
                          value={
                            this.state.DObValue != null
                              ? moment(
                                this.state.DObValue,
                                this.state.dateFormat,
                              )
                              : null
                          }
                        />
                      </Form.Item>
                    </Col>
                  ) : (
                    ''
                  )}

                  {this.state.productId === 3 || this.state.productId === 5 ? (
                    <Col xs={24} md={12} lg={4}>
                      <Form.Item label="Age">
                        <Input
                          disabled
                          placeholder="Age"
                          value={this.state.ageFcp}
                        />
                      </Form.Item>
                    </Col>
                  ) : (
                    ''
                  )}

                  {this.state.productId === 3 || this.state.productId === 5 ? (
                    <Col xs={24} md={12} lg={4}>
                      <Form.Item label="Relationship">
                        {getFieldDecorator('relation', {
                          initialValue: '',
                          rules: this.state.disableAddFieldValidation
                            ? []
                            : [
                              {
                                required: true,

                                message: 'Please input Relationship!',
                              },
                            ],
                        })(
                          <select
                            className="select-input"
                            id="relationshipValue"
                            value={this.state.relationValue}>
                            <option value="">---Select--</option>
                            <option value="Principal Member">
                              Principal Member
                            </option>
                            <option value="Spouse">Spouse</option>
                            <option value="Child">Child</option>
                            <option value="Grand Parent">Grand Parent</option>
                            <option value="Other">Other</option>
                          </select>,
                        )}
                      </Form.Item>
                    </Col>
                  ) : (
                    ''
                  )}

                  {this.state.productId === 3 || this.state.productId === 5 ? (
                    <Col xs={24} md={12} lg={4}>
                      <Form.Item label="Name">
                        {getFieldDecorator('name', {
                          initialValue: '',
                          rules: this.state.disableAddFieldValidation
                            ? []
                            : [
                              {
                                required: true,

                                message: 'Please input Name!',
                              },
                            ],
                        })(<Input placeholder="Name" />)}
                      </Form.Item>
                    </Col>
                  ) : (
                    ''
                  )}

                  {this.state.productId === 3 || this.state.productId === 5 ? (
                    <Col xs={24} md={12} lg={4}>
                      <Form.Item label="Gender">
                        {getFieldDecorator('genderFcp', {
                          initialValue: '',
                          rules: this.state.disableAddFieldValidation
                            ? []
                            : [
                              {
                                required: true,

                                message: 'Please input gender!',
                              },
                            ],
                        })(
                          <select className="select-input">
                            <option value="">---Select--</option>
                            <option value="Male">Male</option>
                            <option value="Female">Female</option>
                          </select>,
                        )}
                      </Form.Item>
                    </Col>
                  ) : (
                    ''
                  )}

                  {this.state.cellphone === true && (
                    <Col xs={24} md={12} lg={4}>
                      <Form.Item label="Model">
                        {/* <Input  onc  placeholder="Address"/> */}
                        {getFieldDecorator('address', {
                          rules: [
                            {
                              required: true,
                              message: 'Please Enter Cellphone model!',
                              whitespace: false,
                            },
                          ],
                        })(<Input placeholder="Cellphone Model" />)}
                      </Form.Item>
                    </Col>
                  )}

                  {(this.state.cellphone === false &&
                    this.state.productId === 1) ||
                    (this.state.cellphone === false &&
                      this.state.productId === 2) ||
                    (this.state.cellphone === false &&
                      this.state.productId === 4) ||
                    (this.state.cellphone === false &&
                      this.state.productId === 12) ||
                    this.state.productId ? (
                    <Col xs={24} md={12} lg={4}>
                      <Form.Item label="Address/Item Details">
                        {getFieldDecorator('address', {
                          rules: this.state.disableAddFieldValidation
                            ? []
                            : [
                              {
                                required: true,
                                message: 'Please enter Address/Item Details!',
                              },
                            ],
                        })(
                          <input
                            className="ant-input"
                          // placeholder="Address/Item Details"
                          />,
                        )}
                      </Form.Item>
                    </Col>
                  ) : (
                    ''
                  )}

                  <Col xs={24} md={12} lg={4} style={{ display: 'none' }}>
                    <Form.Item label="Cover type">
                      <Input
                        placeholder="Cover Type"
                        value={this.state.coverType}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={12} lg={3}>
                    <Form.Item label="Sum Insured">
                      {getFieldDecorator('sumInsured', {
                        rules: this.state.disableAddFieldValidation
                          ? []
                          : [
                            {
                              required: true,
                              message: 'Please enter Amount!',
                              whitespace: false,
                            },
                          ],
                      })(
                        <Input

                          onChange={e => {
                            const value = e.target.value;
                            this.props.form.setFieldsValue({ sumInsured: value });
                            this.setState({ sumInsuredValue: value }, () => {
                              // Conversion logic
                              const { currencyRates, selectedCurrency } = this.state;
                              const numericValue = Number(value);
                              const selectedRateObj = currencyRates?.find(
                                rate => rate.currencyCode === selectedCurrency
                              );
                              const selectedRate = selectedRateObj?.rate || 1;
                              const usdRateObj = currencyRates?.find(
                                rate => rate.currencyCode === 'USD'
                              );
                              const usdRate = usdRateObj?.rate || 1;
                              let usdValue = '';
                              if (!isNaN(numericValue) && numericValue > 0) {
                                usdValue = ((numericValue / selectedRate) * usdRate).toFixed(2);
                              }
                              this.setState({ sumInsuredUSD: usdValue });
                            });
                          }}
                        // placeholder="Amount"
                        />
                      )}
                    </Form.Item>
                  </Col>
                  {/* )} */}
                  {productNameInLocalStorage == 'LEGAL INSURANCE' && (
                    <Col xs={24} md={12} lg={3}>
                      <Form.Item label="Monthly Payment">
                        {getFieldDecorator('monthlyPayment', {
                          rules: [{}],
                        })(
                          <input
                            ref={this.myRef}
                            disabled
                            // placeholder="Amount"
                            className="ant-input"
                          />,
                        )}
                      </Form.Item>
                    </Col>
                  )}

                  {productNameInLocalStorage != 'LEGAL INSURANCE' && (
                    <Col xs={24} md={12} lg={4}>
                      <Form.Item
                        label={
                          this.state.productId === 3
                            ? 'Minimum Rate'
                            : this.state.productId === 5
                              ? 'Minimum PayOut'
                              : 'Minimum Rate(%)'
                        }>
                        <Input
                          placeholder={
                            this.state.productId === 3
                              ? 'Minimum Rate'
                              : this.state.productId === 5
                                ? 'Minimum PayOut'
                                : 'Minimum Rate(%)'
                          }
                          disabled
                          value={parseFloat(this.state.Minimum_rate).toFixed(2)}
                        />
                      </Form.Item>
                    </Col>
                  )}

                  {productNameInLocalStorage !== 'LEGAL INSURANCE' && (
                    <Col xs={24} md={12} lg={2}>
                      <Form.Item
                        label={
                          this.state.productId === 3
                            ? 'Rate'
                            : this.state.productId === 5
                              ? 'PayOut'
                              : 'Rate(%)'
                        }>
                        {getFieldDecorator('rate', {
                          initialValue: parseFloat(this.state.rate).toFixed(2),
                          rules: this.state.disableAddFieldValidation
                            ? []
                            : [
                              {
                                required: true,
                                message: 'Please enter Rate!',
                                whitespace: false,
                              },
                              {
                                validator: (_, value, callback) => {
                                  const rateValue = parseFloat(value)
                                  const minRate = parseFloat(
                                    this.state.Minimum_rate,
                                  )
                                  if (
                                    isNaN(rateValue) ||
                                    rateValue <= minRate
                                  ) {
                                    callback(
                                      `Rate must be greater than ${minRate}`,
                                    )
                                  } else {
                                    callback()
                                  }
                                },
                              },
                            ],
                        })(
                          <Input
                            // placeholder={
                            //   this.state.productId === 3
                            //     ? 'Rate'
                            //     : this.state.productId === 5
                            //     ? 'PayOut'
                            //     : 'Rate(%)'
                            // }
                            onChange={e =>
                              this.setState({ rate: e.target.value })
                            }
                          />,
                        )}
                      </Form.Item>
                    </Col>
                  )}
                  <Col xs={24} md={12} lg={4} style={{ display: 'none' }}>
                    <Form.Item label="Start Date">
                      <DatePicker disabled
                        value={moment(
                          this.state.riskItemStartDate,
                          this.state.dateFormat,
                        )}
                        onChange={this.startdateChangeRiskItem}
                      />
                    </Form.Item>
                  </Col>
                  {(this.state.policyriskcover.toLowerCase().indexOf('motor') > -1 ||
                    this.state.policyriskcover.toLowerCase().indexOf('vehicle') > -1 ||
                    this.state.productName.toLowerCase().indexOf('motor') > -1 ||
                    this.state.productName.toLowerCase().indexOf('motor') > -1) && (
                      <>
                        <Col xs={24} md={12} lg={3}>
                          <Form.Item label="Vehicle Registration">
                            {getFieldDecorator('VehicleRegistration ', {
                              rules: [
                                {
                                  required: true,
                                  message: 'Please enter Vehicle Registration!',
                                  whitespace: false,
                                },
                              ],
                            })(
                              <Input
                                value={this.state.VehicleRegistration}
                                // placeholder="Vehicle Registration"
                                onChange={e =>
                                  this.setState({
                                    VehicleRegistration: e.target.value,
                                  })
                                }
                              />,
                            )}
                          </Form.Item>
                        </Col>
                        <Col xs={24} md={12} lg={3}>
                          <Form.Item label="Make ">
                            {getFieldDecorator('Make', {
                              rules: [
                                {
                                  required: true,
                                  message: 'Please enter Make!',
                                  whitespace: false,
                                },
                              ],
                            })(
                              <Input
                                value={this.state.Make}
                                // placeholder="Make "
                                onChange={e =>
                                  this.setState({ Make: e.target.value })
                                }
                              />,
                            )}
                          </Form.Item>
                        </Col>
                        <Col xs={24} md={12} lg={3}>
                          <Form.Item label="Model">
                            {getFieldDecorator('Model', {
                              rules: [
                                {
                                  required: true,
                                  message: 'Please enter Model!',
                                  whitespace: false,
                                },
                              ],
                            })(
                              <Input
                                value={this.state.Model}
                                // placeholder="Model"
                                onChange={e =>
                                  this.setState({ Model: e.target.value })
                                }
                              />,
                            )}
                          </Form.Item>
                        </Col>
                        <Col xs={24} md={12} lg={3}>
                          <Form.Item label="Year ">
                            {getFieldDecorator('Year ', {
                              rules: [
                                {
                                  required: true,
                                  message: 'Please enter Year!',
                                  whitespace: false,
                                },
                              ],
                            })(
                              <Input
                                value={this.state.Year}
                                // placeholder="Year "
                                onChange={e =>
                                  this.setState({ Year: e.target.value })
                                }
                              />,
                            )}
                          </Form.Item>
                        </Col>
                      </>
                    )}

                  {this.state.editingRecordId == null && (<Col xs={24} md={12} lg={3}>
                    <div className="add-button">
                      <Button
                        htmlType="submit"
                        size="default"
                        className="add-secondary">
                        Add
                      </Button>
                    </div>
                  </Col>)}
                  {this.state.editingRecordId != null && (
                    <Col xs={24} md={12} lg={3}>
                      <div className="add-button">
                        <Button
                          type="button"
                          size="default"
                          className="add-secondary"
                          onClick={this.handleEditSubmit}
                        >
                          Save
                        </Button>
                      </div>
                    </Col>)}
                </Row>
              </Form>
            </div>
            <div className="dash-bg-white no-padding">
              <div
                className={
                  this.state.productId === 5
                    ? 'table-grid-bx width-9 col-th-8'
                    : this.state.productId === 3
                      ? 'table-grid-bx width-11 col-th-10'
                      : 'table-grid-bx width-11'
                }>
                <Table
                  className="table-scroll-auto"
                  columns={
                    this.state.productId === 3 || this.state.productId === 5
                      ? this.state.columnsForFCP
                      : this.state.columns
                  }
                  dataSource={
                    this.state.productId === 3 || this.state.productId === 5
                      ? this.state.dataForFCP
                      : this.state.data
                  }
                  pagination={false}
                  rowKey="key"
                  footer={() => {
                    //  grand totals from handleSubmit state
                    const totals = this.state.data.reduce(
                      (acc, item) => {
                        acc.prorata += Number(item.prorata || 0);
                        acc.annualpremium += Number(item.annualpremium || 0);
                        acc.termpremium += Number(item.termpremium || 0);
                        acc.suminsured += Number(item.suminsured || 0);
                        return acc;
                      },
                      { prorata: 0, annualpremium: 0, termpremium: 0, suminsured: 0 }
                    );

                    let taxAmounts = [];

                    if (localStorage.getItem("productName").toLowerCase().includes("motor")) {
                      taxAmounts = this.state.taxes
                        .filter(tax => {
                          if (tax.taxName.toLowerCase().includes("government levy")) {
                            if (this.state.entitytype === "Individual") {
                              return tax.taxName.toLowerCase().includes("private");
                            } else if (this.state.entitytype === "Business") {
                              return tax.taxName.toLowerCase().includes("commercial");
                            }
                            return false;
                          }
                          return true;
                        })
                        .map(tax => {
                          const months = Number(this.state.paymentterm);
                          let amounts = {};
                          if (tax.taxName.toLowerCase().includes("private") || tax.taxName.toLowerCase().includes("commercial")) {
                            const prorated = (tax.ratePercentage / 12) * months;
                            const levyValue = Math.max(prorated, 2);
                            amounts = {
                              prorata: 0,
                              annualpremium: tax.ratePercentage,
                              termpremium: levyValue,
                            };
                          } else if (tax.taxName.toLowerCase().includes("stamp duty")) {
                            amounts = {
                              prorata: 0,
                              annualpremium: totals.annualpremium * (tax.ratePercentage / 100),
                              termpremium: totals.termpremium * (tax.ratePercentage / 100),
                            };
                          } else {
                            amounts = {
                              prorata: 0,
                              annualpremium: totals.annualpremium * (tax.ratePercentage / 100),
                              termpremium: totals.termpremium * (tax.ratePercentage / 100),
                            };
                          }
                          return { ...tax, amounts };
                        });
                    } else {
                      taxAmounts = this.state.taxes
                        .filter(tax => !tax.taxName.toLowerCase().includes("government levy"))
                        .map(tax => ({
                          ...tax,
                          amounts: {
                            prorata: totals.prorata * (tax.ratePercentage / 100),
                            annualpremium: totals.annualpremium * (tax.ratePercentage / 100),
                            termpremium: totals.termpremium * (tax.ratePercentage / 100),
                          },
                        }));
                    }
                    const renderHeadingRow = () => (
                      <div style={{ display: "flex", borderBottom: "2px solid #000", padding: "8px 0", fontWeight: "bold", background: "#fafafa" }}>
                        <div style={{ flex: 1 }}>Description</div>
                        <div style={{ flex: 1, textAlign: "right", padding: "0 8px" }}>Annual Premium</div>
                        <div style={{ flex: 1, textAlign: "right", padding: "0 8px" }}>Term Premium</div>
                      </div>
                    );

                    const renderRow = (label, values, isBold = false) => (
                      <div style={{ display: "flex", borderBottom: "1px solid #e8e8e8", padding: "8px 0", fontWeight: isBold ? "bold" : "normal" }}>
                        <div style={{ flex: 1 }}>{label}</div>
                        <div style={{ flex: 1, textAlign: "right" }}>{values.annualpremium?.toFixed(2) || "0.00"}</div>
                        <div style={{ flex: 1, textAlign: "right" }}>{values.termpremium?.toFixed(2) || "0.00"}</div>
                      </div>
                    );

                    return (
                      <div>
                        {renderHeadingRow()}
                        {renderRow("Total", this.state.footerTotals)}
                        {taxAmounts.map((tax, i) => renderRow(tax.taxName, tax.amounts))}
                        {renderRow("Grand Total", this.state.grandTotals, true)}
                      </div>
                    );
                  }}

                />
              </div>
              {this.state.data !== null && (
                <div className="btn-group-success">
                  <Button
                    size="default"
                    value={'submit'}
                    className="btn-success"
                    onClick={this.submitpolicy}>
                    Submit
                  </Button>
                </div>
              )}
            </div>
          </>
        )}

        <Modal
          centered
          visible={this.state.CreditNoteVisible}
          footer={null}
          onCancel={this.setVisibleFalse}
          width={1000}></Modal>
      </Layout>
    )
  }
}

const WrappedHomeInsurancePolicy = Form.create({ name: 'Homeinsurance_list' })(
  withRouter(HomeInsurancePolicy),
)

export default WrappedHomeInsurancePolicy
